const weightPercentilesRaw = [
  {
    sex: 'male',
    ageInMonths: '24',
    p5: '10.64009004',
    p95: '15.18777349',
  },
  {
    sex: 'male',
    ageInMonths: '24.5',
    p5: '10.70051298',
    p95: '15.27629562',
  },
  {
    sex: 'male',
    ageInMonths: '25.5',
    p5: '10.81957536',
    p95: '15.45242405',
  },
  {
    sex: 'male',
    ageInMonths: '26.5',
    p5: '10.93681171',
    p95: '15.62818936',
  },
  {
    sex: 'male',
    ageInMonths: '27.5',
    p5: '11.05280067',
    p95: '15.80450043',
  },
  {
    sex: 'male',
    ageInMonths: '28.5',
    p5: '11.168034',
    p95: '15.98213866',
  },
  {
    sex: 'male',
    ageInMonths: '29.5',
    p5: '11.28292555',
    p95: '16.16176896',
  },
  {
    sex: 'male',
    ageInMonths: '30.5',
    p5: '11.3978197',
    p95: '16.34395025',
  },
  {
    sex: 'male',
    ageInMonths: '31.5',
    p5: '11.51299966',
    p95: '16.52914562',
  },
  {
    sex: 'male',
    ageInMonths: '32.5',
    p5: '11.62869248',
    p95: '16.71773017',
  },
  {
    sex: 'male',
    ageInMonths: '33.5',
    p5: '11.74507892',
    p95: '16.91000204',
  },
  {
    sex: 'male',
    ageInMonths: '34.5',
    p5: '11.86229971',
    p95: '17.10619066',
  },
  {
    sex: 'male',
    ageInMonths: '35.5',
    p5: '11.98045644',
    p95: '17.30646132',
  },
  {
    sex: 'male',
    ageInMonths: '36.5',
    p5: '12.09962308',
    p95: '17.51092666',
  },
  {
    sex: 'male',
    ageInMonths: '37.5',
    p5: '12.21984466',
    p95: '17.7196494',
  },
  {
    sex: 'male',
    ageInMonths: '38.5',
    p5: '12.34114672',
    p95: '17.93265202',
  },
  {
    sex: 'male',
    ageInMonths: '39.5',
    p5: '12.46353554',
    p95: '18.14992024',
  },
  {
    sex: 'male',
    ageInMonths: '40.5',
    p5: '12.5870056',
    p95: '18.37141087',
  },
  {
    sex: 'male',
    ageInMonths: '41.5',
    p5: '12.71153714',
    p95: '18.59705318',
  },
  {
    sex: 'male',
    ageInMonths: '42.5',
    p5: '12.83710098',
    p95: '18.8267549',
  },
  {
    sex: 'male',
    ageInMonths: '43.5',
    p5: '12.96366474',
    p95: '19.06040859',
  },
  {
    sex: 'male',
    ageInMonths: '44.5',
    p5: '13.09118938',
    p95: '19.29789203',
  },
  {
    sex: 'male',
    ageInMonths: '45.5',
    p5: '13.21963362',
    p95: '19.53907323',
  },
  {
    sex: 'male',
    ageInMonths: '46.5',
    p5: '13.34895376',
    p95: '19.78381251',
  },
  {
    sex: 'male',
    ageInMonths: '47.5',
    p5: '13.47910915',
    p95: '20.03196776',
  },
  {
    sex: 'male',
    ageInMonths: '48.5',
    p5: '13.61005739',
    p95: '20.28339348',
  },
  {
    sex: 'male',
    ageInMonths: '49.5',
    p5: '13.74175874',
    p95: '20.53794512',
  },
  {
    sex: 'male',
    ageInMonths: '50.5',
    p5: '13.87417598',
    p95: '20.79548054',
  },
  {
    sex: 'male',
    ageInMonths: '51.5',
    p5: '14.0072749',
    p95: '21.05586181',
  },
  {
    sex: 'male',
    ageInMonths: '52.5',
    p5: '14.14102471',
    p95: '21.31895671',
  },
  {
    sex: 'male',
    ageInMonths: '53.5',
    p5: '14.27539832',
    p95: '21.58464011',
  },
  {
    sex: 'male',
    ageInMonths: '54.5',
    p5: '14.41037252',
    p95: '21.85279508',
  },
  {
    sex: 'male',
    ageInMonths: '55.5',
    p5: '14.54592801',
    p95: '22.12331387',
  },
  {
    sex: 'male',
    ageInMonths: '56.5',
    p5: '14.68204842',
    p95: '22.3960982',
  },
  {
    sex: 'male',
    ageInMonths: '57.5',
    p5: '14.81872422',
    p95: '22.67106204',
  },
  {
    sex: 'male',
    ageInMonths: '58.5',
    p5: '14.95594682',
    p95: '22.94812899',
  },
  {
    sex: 'male',
    ageInMonths: '59.5',
    p5: '15.09371211',
    p95: '23.22723469',
  },
  {
    sex: 'male',
    ageInMonths: '60.5',
    p5: '15.23201937',
    p95: '23.50832656',
  },
  {
    sex: 'male',
    ageInMonths: '61.5',
    p5: '15.37087094',
    p95: '23.79136391',
  },
  {
    sex: 'male',
    ageInMonths: '62.5',
    p5: '15.51027205',
    p95: '24.07631802',
  },
  {
    sex: 'male',
    ageInMonths: '63.5',
    p5: '15.65023042',
    p95: '24.36317198',
  },
  {
    sex: 'male',
    ageInMonths: '64.5',
    p5: '15.79075599',
    p95: '24.65192058',
  },
  {
    sex: 'male',
    ageInMonths: '65.5',
    p5: '15.93186059',
    p95: '24.94257',
  },
  {
    sex: 'male',
    ageInMonths: '66.5',
    p5: '16.07355758',
    p95: '25.23513755',
  },
  {
    sex: 'male',
    ageInMonths: '67.5',
    p5: '16.21586154',
    p95: '25.52965118',
  },
  {
    sex: 'male',
    ageInMonths: '68.5',
    p5: '16.35878793',
    p95: '25.82614911',
  },
  {
    sex: 'male',
    ageInMonths: '69.5',
    p5: '16.50235277',
    p95: '26.12467926',
  },
  {
    sex: 'male',
    ageInMonths: '70.5',
    p5: '16.64657235',
    p95: '26.42529873',
  },
  {
    sex: 'male',
    ageInMonths: '71.5',
    p5: '16.79146158',
    p95: '26.72807261',
  },
  {
    sex: 'male',
    ageInMonths: '72.5',
    p5: '16.93703875',
    p95: '27.03307565',
  },
  {
    sex: 'male',
    ageInMonths: '73.5',
    p5: '17.08331814',
    p95: '27.34038832',
  },
  {
    sex: 'male',
    ageInMonths: '74.5',
    p5: '17.23031439',
    p95: '27.6500983',
  },
  {
    sex: 'male',
    ageInMonths: '75.5',
    p5: '17.37804118',
    p95: '27.96229925',
  },
  {
    sex: 'male',
    ageInMonths: '76.5',
    p5: '17.52651109',
    p95: '28.27709021',
  },
  {
    sex: 'male',
    ageInMonths: '77.5',
    p5: '17.6757355',
    p95: '28.59457486',
  },
  {
    sex: 'male',
    ageInMonths: '78.5',
    p5: '17.82572453',
    p95: '28.91486092',
  },
  {
    sex: 'male',
    ageInMonths: '79.5',
    p5: '17.97648696',
    p95: '29.23805946',
  },
  {
    sex: 'male',
    ageInMonths: '80.5',
    p5: '18.12802886',
    p95: '29.56428369',
  },
  {
    sex: 'male',
    ageInMonths: '81.5',
    p5: '18.28035866',
    p95: '29.89365038',
  },
  {
    sex: 'male',
    ageInMonths: '82.5',
    p5: '18.4334803',
    p95: '30.2262764',
  },
  {
    sex: 'male',
    ageInMonths: '83.5',
    p5: '18.58739757',
    p95: '30.56227989',
  },
  {
    sex: 'male',
    ageInMonths: '84.5',
    p5: '18.74211363',
    p95: '30.90177938',
  },
  {
    sex: 'male',
    ageInMonths: '85.5',
    p5: '18.89762965',
    p95: '31.24489263',
  },
  {
    sex: 'male',
    ageInMonths: '86.5',
    p5: '19.05394835',
    p95: '31.59173734',
  },
  {
    sex: 'male',
    ageInMonths: '87.5',
    p5: '19.21107044',
    p95: '31.94242919',
  },
  {
    sex: 'male',
    ageInMonths: '88.5',
    p5: '19.36899699',
    p95: '32.29708214',
  },
  {
    sex: 'male',
    ageInMonths: '89.5',
    p5: '19.52772926',
    p95: '32.65580771',
  },
  {
    sex: 'male',
    ageInMonths: '90.5',
    p5: '19.68726895',
    p95: '33.01871449',
  },
  {
    sex: 'male',
    ageInMonths: '91.5',
    p5: '19.84761848',
    p95: '33.38590769',
  },
  {
    sex: 'male',
    ageInMonths: '92.5',
    p5: '20.00878127',
    p95: '33.75748861',
  },
  {
    sex: 'male',
    ageInMonths: '93.5',
    p5: '20.17076208',
    p95: '34.13355425',
  },
  {
    sex: 'male',
    ageInMonths: '94.5',
    p5: '20.33356558',
    p95: '34.51419632',
  },
  {
    sex: 'male',
    ageInMonths: '95.5',
    p5: '20.49720276',
    p95: '34.89950266',
  },
  {
    sex: 'male',
    ageInMonths: '96.5',
    p5: '20.66168259',
    p95: '35.28955426',
  },
  {
    sex: 'male',
    ageInMonths: '97.5',
    p5: '20.82701772',
    p95: '35.68442647',
  },
  {
    sex: 'male',
    ageInMonths: '98.5',
    p5: '20.9932234',
    p95: '36.08418823',
  },
  {
    sex: 'male',
    ageInMonths: '99.5',
    p5: '21.16031766',
    p95: '36.48890176',
  },
  {
    sex: 'male',
    ageInMonths: '100.5',
    p5: '21.32832161',
    p95: '36.89862215',
  },
  {
    sex: 'male',
    ageInMonths: '101.5',
    p5: '21.49725951',
    p95: '37.31339712',
  },
  {
    sex: 'male',
    ageInMonths: '102.5',
    p5: '21.66715902',
    p95: '37.73326669',
  },
  {
    sex: 'male',
    ageInMonths: '103.5',
    p5: '21.83805093',
    p95: '38.15826287',
  },
  {
    sex: 'male',
    ageInMonths: '104.5',
    p5: '22.00997207',
    p95: '38.5884101',
  },
  {
    sex: 'male',
    ageInMonths: '105.5',
    p5: '22.18295884',
    p95: '39.02372343',
  },
  {
    sex: 'male',
    ageInMonths: '106.5',
    p5: '22.35705429',
    p95: '39.46421007',
  },
  {
    sex: 'male',
    ageInMonths: '107.5',
    p5: '22.53230492',
    p95: '39.90986854',
  },
  {
    sex: 'male',
    ageInMonths: '108.5',
    p5: '22.70876108',
    p95: '40.36068858',
  },
  {
    sex: 'male',
    ageInMonths: '109.5',
    p5: '22.8864771',
    p95: '40.81665117',
  },
  {
    sex: 'male',
    ageInMonths: '110.5',
    p5: '23.06551129',
    p95: '41.27772848',
  },
  {
    sex: 'male',
    ageInMonths: '111.5',
    p5: '23.24592593',
    p95: '41.74388392',
  },
  {
    sex: 'male',
    ageInMonths: '112.5',
    p5: '23.42778723',
    p95: '42.21507216',
  },
  {
    sex: 'male',
    ageInMonths: '113.5',
    p5: '23.61116524',
    p95: '42.69123922',
  },
  {
    sex: 'male',
    ageInMonths: '114.5',
    p5: '23.79613202',
    p95: '43.17232241',
  },
  {
    sex: 'male',
    ageInMonths: '115.5',
    p5: '23.98276774',
    p95: '43.65825106',
  },
  {
    sex: 'male',
    ageInMonths: '116.5',
    p5: '24.17115246',
    p95: '44.14894598',
  },
  {
    sex: 'male',
    ageInMonths: '117.5',
    p5: '24.36137073',
    p95: '44.64432008',
  },
  {
    sex: 'male',
    ageInMonths: '118.5',
    p5: '24.55351042',
    p95: '45.1442785',
  },
  {
    sex: 'male',
    ageInMonths: '119.5',
    p5: '24.74766249',
    p95: '45.64871885',
  },
  {
    sex: 'male',
    ageInMonths: '120.5',
    p5: '24.94392079',
    p95: '46.15753154',
  },
  {
    sex: 'male',
    ageInMonths: '121.5',
    p5: '25.14238189',
    p95: '46.67060006',
  },
  {
    sex: 'male',
    ageInMonths: '122.5',
    p5: '25.34314479',
    p95: '47.18780128',
  },
  {
    sex: 'male',
    ageInMonths: '123.5',
    p5: '25.54631065',
    p95: '47.70900582',
  },
  {
    sex: 'male',
    ageInMonths: '124.5',
    p5: '25.75198256',
    p95: '48.23407839',
  },
  {
    sex: 'male',
    ageInMonths: '125.5',
    p5: '25.96026515',
    p95: '48.76287816',
  },
  {
    sex: 'male',
    ageInMonths: '126.5',
    p5: '26.17126436',
    p95: '49.29525914',
  },
  {
    sex: 'male',
    ageInMonths: '127.5',
    p5: '26.38508699',
    p95: '49.83107058',
  },
  {
    sex: 'male',
    ageInMonths: '128.5',
    p5: '26.60184044',
    p95: '50.37015732',
  },
  {
    sex: 'male',
    ageInMonths: '129.5',
    p5: '26.82163224',
    p95: '50.91236024',
  },
  {
    sex: 'male',
    ageInMonths: '130.5',
    p5: '27.0445704',
    p95: '51.45751679',
  },
  {
    sex: 'male',
    ageInMonths: '131.5',
    p5: '27.27075818',
    p95: '52.00546039',
  },
  {
    sex: 'male',
    ageInMonths: '132.5',
    p5: '27.50030694',
    p95: '52.55602363',
  },
  {
    sex: 'male',
    ageInMonths: '133.5',
    p5: '27.73331628',
    p95: '53.10903452',
  },
  {
    sex: 'male',
    ageInMonths: '134.5',
    p5: '27.96988937',
    p95: '53.66432034',
  },
  {
    sex: 'male',
    ageInMonths: '135.5',
    p5: '28.21012567',
    p95: '54.22170647',
  },
  {
    sex: 'male',
    ageInMonths: '136.5',
    p5: '28.45412164',
    p95: '54.7810171',
  },
  {
    sex: 'male',
    ageInMonths: '137.5',
    p5: '28.70197022',
    p95: '55.34207557',
  },
  {
    sex: 'male',
    ageInMonths: '138.5',
    p5: '28.95376036',
    p95: '55.90470472',
  },
  {
    sex: 'male',
    ageInMonths: '139.5',
    p5: '29.20957645',
    p95: '56.46872726',
  },
  {
    sex: 'male',
    ageInMonths: '140.5',
    p5: '29.46949781',
    p95: '57.03396609',
  },
  {
    sex: 'male',
    ageInMonths: '141.5',
    p5: '29.73359819',
    p95: '57.6002446',
  },
  {
    sex: 'male',
    ageInMonths: '142.5',
    p5: '30.00194519',
    p95: '58.167387',
  },
  {
    sex: 'male',
    ageInMonths: '143.5',
    p5: '30.27459974',
    p95: '58.73521857',
  },
  {
    sex: 'male',
    ageInMonths: '144.5',
    p5: '30.55161562',
    p95: '59.30356596',
  },
  {
    sex: 'male',
    ageInMonths: '145.5',
    p5: '30.83303885',
    p95: '59.87225739',
  },
  {
    sex: 'male',
    ageInMonths: '146.5',
    p5: '31.11890724',
    p95: '60.44112289',
  },
  {
    sex: 'male',
    ageInMonths: '147.5',
    p5: '31.40924987',
    p95: '61.00999451',
  },
  {
    sex: 'male',
    ageInMonths: '148.5',
    p5: '31.70408654',
    p95: '61.5787065',
  },
  {
    sex: 'male',
    ageInMonths: '149.5',
    p5: '32.00342738',
    p95: '62.14709543',
  },
  {
    sex: 'male',
    ageInMonths: '150.5',
    p5: '32.30727227',
    p95: '62.71500036',
  },
  {
    sex: 'male',
    ageInMonths: '151.5',
    p5: '32.61560983',
    p95: '63.28226272',
  },
  {
    sex: 'male',
    ageInMonths: '152.5',
    p5: '32.92841993',
    p95: '63.84872734',
  },
  {
    sex: 'male',
    ageInMonths: '153.5',
    p5: '33.24566815',
    p95: '64.41424088',
  },
  {
    sex: 'male',
    ageInMonths: '154.5',
    p5: '33.56730937',
    p95: '64.97865313',
  },
  {
    sex: 'male',
    ageInMonths: '155.5',
    p5: '33.8932863',
    p95: '65.54181664',
  },
  {
    sex: 'male',
    ageInMonths: '156.5',
    p5: '34.22352911',
    p95: '66.1035867',
  },
  {
    sex: 'male',
    ageInMonths: '157.5',
    p5: '34.5579552',
    p95: '66.66382131',
  },
  {
    sex: 'male',
    ageInMonths: '158.5',
    p5: '34.8964689',
    p95: '67.22238111',
  },
  {
    sex: 'male',
    ageInMonths: '159.5',
    p5: '35.23896126',
    p95: '67.77912926',
  },
  {
    sex: 'male',
    ageInMonths: '160.5',
    p5: '35.58530989',
    p95: '68.33393136',
  },
  {
    sex: 'male',
    ageInMonths: '161.5',
    p5: '35.9353771',
    p95: '68.88665453',
  },
  {
    sex: 'male',
    ageInMonths: '162.5',
    p5: '36.28901539',
    p95: '69.43716965',
  },
  {
    sex: 'male',
    ageInMonths: '163.5',
    p5: '36.64606043',
    p95: '69.98534819',
  },
  {
    sex: 'male',
    ageInMonths: '164.5',
    p5: '37.00633501',
    p95: '70.53106367',
  },
  {
    sex: 'male',
    ageInMonths: '165.5',
    p5: '37.36964826',
    p95: '71.07419108',
  },
  {
    sex: 'male',
    ageInMonths: '166.5',
    p5: '37.73579576',
    p95: '71.6146066',
  },
  {
    sex: 'male',
    ageInMonths: '167.5',
    p5: '38.10455963',
    p95: '72.15218736',
  },
  {
    sex: 'male',
    ageInMonths: '168.5',
    p5: '38.47570882',
    p95: '72.68681109',
  },
  {
    sex: 'male',
    ageInMonths: '169.5',
    p5: '38.84899932',
    p95: '73.21835588',
  },
  {
    sex: 'male',
    ageInMonths: '170.5',
    p5: '39.22417451',
    p95: '73.7466998',
  },
  {
    sex: 'male',
    ageInMonths: '171.5',
    p5: '39.60096552',
    p95: '74.27172061',
  },
  {
    sex: 'male',
    ageInMonths: '172.5',
    p5: '39.97909172',
    p95: '74.79329538',
  },
  {
    sex: 'male',
    ageInMonths: '173.5',
    p5: '40.35826115',
    p95: '75.31130018',
  },
  {
    sex: 'male',
    ageInMonths: '174.5',
    p5: '40.73817116',
    p95: '75.82560968',
  },
  {
    sex: 'male',
    ageInMonths: '175.5',
    p5: '41.118509',
    p95: '76.33609688',
  },
  {
    sex: 'male',
    ageInMonths: '176.5',
    p5: '41.49895256',
    p95: '76.84263269',
  },
  {
    sex: 'male',
    ageInMonths: '177.5',
    p5: '41.8791711',
    p95: '77.34508562',
  },
  {
    sex: 'male',
    ageInMonths: '178.5',
    p5: '42.25882349',
    p95: '77.84332029',
  },
  {
    sex: 'male',
    ageInMonths: '179.5',
    p5: '42.63757221',
    p95: '78.33720309',
  },
  {
    sex: 'male',
    ageInMonths: '180.5',
    p5: '43.01505816',
    p95: '78.82658994',
  },
  {
    sex: 'male',
    ageInMonths: '181.5',
    p5: '43.39092788',
    p95: '79.31133801',
  },
  {
    sex: 'male',
    ageInMonths: '182.5',
    p5: '43.76482163',
    p95: '79.79129954',
  },
  {
    sex: 'male',
    ageInMonths: '183.5',
    p5: '44.13637714',
    p95: '80.26632286',
  },
  {
    sex: 'male',
    ageInMonths: '184.5',
    p5: '44.50523096',
    p95: '80.73625224',
  },
  {
    sex: 'male',
    ageInMonths: '185.5',
    p5: '44.87101979',
    p95: '81.20092786',
  },
  {
    sex: 'male',
    ageInMonths: '186.5',
    p5: '45.23337973',
    p95: '81.66018503',
  },
  {
    sex: 'male',
    ageInMonths: '187.5',
    p5: '45.59195858',
    p95: '82.11385795',
  },
  {
    sex: 'male',
    ageInMonths: '188.5',
    p5: '45.94639581',
    p95: '82.56177239',
  },
  {
    sex: 'male',
    ageInMonths: '189.5',
    p5: '46.29634576',
    p95: '83.00375329',
  },
  {
    sex: 'male',
    ageInMonths: '190.5',
    p5: '46.64147321',
    p95: '83.43962339',
  },
  {
    sex: 'male',
    ageInMonths: '191.5',
    p5: '46.98143987',
    p95: '83.8691966',
  },
  {
    sex: 'male',
    ageInMonths: '192.5',
    p5: '47.31593016',
    p95: '84.29228904',
  },
  {
    sex: 'male',
    ageInMonths: '193.5',
    p5: '47.64463827',
    p95: '84.70871297',
  },
  {
    sex: 'male',
    ageInMonths: '194.5',
    p5: '47.96727332',
    p95: '85.1182789',
  },
  {
    sex: 'male',
    ageInMonths: '195.5',
    p5: '48.2835611',
    p95: '85.52079616',
  },
  {
    sex: 'male',
    ageInMonths: '196.5',
    p5: '48.59324591',
    p95: '85.91607365',
  },
  {
    sex: 'male',
    ageInMonths: '197.5',
    p5: '48.89609218',
    p95: '86.30392061',
  },
  {
    sex: 'male',
    ageInMonths: '198.5',
    p5: '49.1918862',
    p95: '86.68414749',
  },
  {
    sex: 'male',
    ageInMonths: '199.5',
    p5: '49.4804377',
    p95: '87.0565669',
  },
  {
    sex: 'male',
    ageInMonths: '200.5',
    p5: '49.76158125',
    p95: '87.42099463',
  },
  {
    sex: 'male',
    ageInMonths: '201.5',
    p5: '50.03517772',
    p95: '87.77725073',
  },
  {
    sex: 'male',
    ageInMonths: '202.5',
    p5: '50.30111539',
    p95: '88.12516072',
  },
  {
    sex: 'male',
    ageInMonths: '203.5',
    p5: '50.55931105',
    p95: '88.46455683',
  },
  {
    sex: 'male',
    ageInMonths: '204.5',
    p5: '50.8097108',
    p95: '88.79527942',
  },
  {
    sex: 'male',
    ageInMonths: '205.5',
    p5: '51.05229071',
    p95: '89.11717836',
  },
  {
    sex: 'male',
    ageInMonths: '206.5',
    p5: '51.28705716',
    p95: '89.43011463',
  },
  {
    sex: 'male',
    ageInMonths: '207.5',
    p5: '51.51404335',
    p95: '89.73396054',
  },
  {
    sex: 'male',
    ageInMonths: '208.5',
    p5: '51.73332523',
    p95: '90.02860798',
  },
  {
    sex: 'male',
    ageInMonths: '209.5',
    p5: '51.94499451',
    p95: '90.31395969',
  },
  {
    sex: 'male',
    ageInMonths: '210.5',
    p5: '52.14917717',
    p95: '90.58993909',
  },
  {
    sex: 'male',
    ageInMonths: '211.5',
    p5: '52.34602709',
    p95: '90.85649043',
  },
  {
    sex: 'male',
    ageInMonths: '212.5',
    p5: '52.53572455',
    p95: '91.11358115',
  },
  {
    sex: 'male',
    ageInMonths: '213.5',
    p5: '52.71847428',
    p95: '91.36120451',
  },
  {
    sex: 'male',
    ageInMonths: '214.5',
    p5: '52.89450319',
    p95: '91.59938232',
  },
  {
    sex: 'male',
    ageInMonths: '215.5',
    p5: '53.06405769',
    p95: '91.82816795',
  },
  {
    sex: 'male',
    ageInMonths: '216.5',
    p5: '53.22740059',
    p95: '92.04764958',
  },
  {
    sex: 'male',
    ageInMonths: '217.5',
    p5: '53.38480749',
    p95: '92.25795363',
  },
  {
    sex: 'male',
    ageInMonths: '218.5',
    p5: '53.53656883',
    p95: '92.4592488',
  },
  {
    sex: 'male',
    ageInMonths: '219.5',
    p5: '53.68296205',
    p95: '92.65174946',
  },
  {
    sex: 'male',
    ageInMonths: '220.5',
    p5: '53.82427723',
    p95: '92.83571985',
  },
  {
    sex: 'male',
    ageInMonths: '221.5',
    p5: '53.96079321',
    p95: '93.0114792',
  },
  {
    sex: 'male',
    ageInMonths: '222.5',
    p5: '54.09277512',
    p95: '93.17940638',
  },
  {
    sex: 'male',
    ageInMonths: '223.5',
    p5: '54.22046291',
    p95: '93.33994398',
  },
  {
    sex: 'male',
    ageInMonths: '224.5',
    p5: '54.34408388',
    p95: '93.49360895',
  },
  {
    sex: 'male',
    ageInMonths: '225.5',
    p5: '54.46381004',
    p95: '93.64099003',
  },
  {
    sex: 'male',
    ageInMonths: '226.5',
    p5: '54.57977424',
    p95: '93.7827601',
  },
  {
    sex: 'male',
    ageInMonths: '227.5',
    p5: '54.69205355',
    p95: '93.91968135',
  },
  {
    sex: 'male',
    ageInMonths: '228.5',
    p5: '54.80065842',
    p95: '94.05261232',
  },
  {
    sex: 'male',
    ageInMonths: '229.5',
    p5: '54.90552089',
    p95: '94.18251529',
  },
  {
    sex: 'male',
    ageInMonths: '230.5',
    p5: '55.00648181',
    p95: '94.31046411',
  },
  {
    sex: 'male',
    ageInMonths: '231.5',
    p5: '55.10327703',
    p95: '94.43765234',
  },
  {
    sex: 'male',
    ageInMonths: '232.5',
    p5: '55.19552245',
    p95: '94.56540179',
  },
  {
    sex: 'male',
    ageInMonths: '233.5',
    p5: '55.28269761',
    p95: '94.69517136',
  },
  {
    sex: 'male',
    ageInMonths: '234.5',
    p5: '55.36412796',
    p95: '94.82856611',
  },
  {
    sex: 'male',
    ageInMonths: '235.5',
    p5: '55.43896526',
    p95: '94.96734651',
  },
  {
    sex: 'male',
    ageInMonths: '236.5',
    p5: '55.50616614',
    p95: '95.11343784',
  },
  {
    sex: 'male',
    ageInMonths: '237.5',
    p5: '55.56446839',
    p95: '95.26893942',
  },
  {
    sex: 'male',
    ageInMonths: '238.5',
    p5: '55.61235958',
    p95: '95.43613181',
  },
  {
    sex: 'male',
    ageInMonths: '239.5',
    p5: '55.64806673',
    p95: '95.61749303',
  },
  {
    sex: 'male',
    ageInMonths: '240',
    p5: '55.66071006',
    p95: '95.71431427',
  },
  {
    sex: 'female',
    ageInMonths: '24',
    p5: '10.2102741',
    p95: '14.56636479',
  },
  {
    sex: 'female',
    ageInMonths: '24.5',
    p5: '10.27482893',
    p95: '14.67658551',
  },
  {
    sex: 'female',
    ageInMonths: '25.5',
    p5: '10.40066415',
    p95: '14.89587242',
  },
  {
    sex: 'female',
    ageInMonths: '26.5',
    p5: '10.52273569',
    p95: '15.1142761',
  },
  {
    sex: 'female',
    ageInMonths: '27.5',
    p5: '10.64171007',
    p95: '15.33249457',
  },
  {
    sex: 'female',
    ageInMonths: '28.5',
    p5: '10.7581918',
    p95: '15.55113065',
  },
  {
    sex: 'female',
    ageInMonths: '29.5',
    p5: '10.8727282',
    p95: '15.770701',
  },
  {
    sex: 'female',
    ageInMonths: '30.5',
    p5: '10.98581228',
    p95: '15.99164336',
  },
  {
    sex: 'female',
    ageInMonths: '31.5',
    p5: '11.09788597',
    p95: '16.21432377',
  },
  {
    sex: 'female',
    ageInMonths: '32.5',
    p5: '11.2093447',
    p95: '16.43904429',
  },
  {
    sex: 'female',
    ageInMonths: '33.5',
    p5: '11.32053778',
    p95: '16.66604785',
  },
  {
    sex: 'female',
    ageInMonths: '34.5',
    p5: '11.43177357',
    p95: '16.89552564',
  },
  {
    sex: 'female',
    ageInMonths: '35.5',
    p5: '11.54332263',
    p95: '17.12762297',
  },
  {
    sex: 'female',
    ageInMonths: '36.5',
    p5: '11.65541879',
    p95: '17.3624437',
  },
  {
    sex: 'female',
    ageInMonths: '37.5',
    p5: '11.76826286',
    p95: '17.60005585',
  },
  {
    sex: 'female',
    ageInMonths: '38.5',
    p5: '11.88202491',
    p95: '17.84049621',
  },
  {
    sex: 'female',
    ageInMonths: '39.5',
    p5: '11.99684628',
    p95: '18.08377443',
  },
  {
    sex: 'female',
    ageInMonths: '40.5',
    p5: '12.11284345',
    p95: '18.329878',
  },
  {
    sex: 'female',
    ageInMonths: '41.5',
    p5: '12.23010816',
    p95: '18.57877485',
  },
  {
    sex: 'female',
    ageInMonths: '42.5',
    p5: '12.34871076',
    p95: '18.83041754',
  },
  {
    sex: 'female',
    ageInMonths: '43.5',
    p5: '12.46870194',
    p95: '19.08474635',
  },
  {
    sex: 'female',
    ageInMonths: '44.5',
    p5: '12.59011469',
    p95: '19.34169227',
  },
  {
    sex: 'female',
    ageInMonths: '45.5',
    p5: '12.71296607',
    p95: '19.60117968',
  },
  {
    sex: 'female',
    ageInMonths: '46.5',
    p5: '12.837259',
    p95: '19.86312888',
  },
  {
    sex: 'female',
    ageInMonths: '47.5',
    p5: '12.96298387',
    p95: '20.12745836',
  },
  {
    sex: 'female',
    ageInMonths: '48.5',
    p5: '13.09012012',
    p95: '20.3940868',
  },
  {
    sex: 'female',
    ageInMonths: '49.5',
    p5: '13.21863694',
    p95: '20.66293462',
  },
  {
    sex: 'female',
    ageInMonths: '50.5',
    p5: '13.34849756',
    p95: '20.93392691',
  },
  {
    sex: 'female',
    ageInMonths: '51.5',
    p5: '13.47965651',
    p95: '21.20699305',
  },
  {
    sex: 'female',
    ageInMonths: '52.5',
    p5: '13.61206342',
    p95: '21.48206912',
  },
  {
    sex: 'female',
    ageInMonths: '53.5',
    p5: '13.74566354',
    p95: '21.75909881',
  },
  {
    sex: 'female',
    ageInMonths: '54.5',
    p5: '13.88039891',
    p95: '22.0380343',
  },
  {
    sex: 'female',
    ageInMonths: '55.5',
    p5: '14.0162093',
    p95: '22.31883709',
  },
  {
    sex: 'female',
    ageInMonths: '56.5',
    p5: '14.15303322',
    p95: '22.60147865',
  },
  {
    sex: 'female',
    ageInMonths: '57.5',
    p5: '14.29080875',
    p95: '22.88594093',
  },
  {
    sex: 'female',
    ageInMonths: '58.5',
    p5: '14.42947441',
    p95: '23.17221677',
  },
  {
    sex: 'female',
    ageInMonths: '59.5',
    p5: '14.56896986',
    p95: '23.46031012',
  },
  {
    sex: 'female',
    ageInMonths: '60.5',
    p5: '14.70923661',
    p95: '23.75023626',
  },
  {
    sex: 'female',
    ageInMonths: '61.5',
    p5: '14.85021811',
    p95: '24.04202158',
  },
  {
    sex: 'female',
    ageInMonths: '62.5',
    p5: '14.9918623',
    p95: '24.33570429',
  },
  {
    sex: 'female',
    ageInMonths: '63.5',
    p5: '15.13411929',
    p95: '24.63133325',
  },
  {
    sex: 'female',
    ageInMonths: '64.5',
    p5: '15.27694359',
    p95: '24.92896835',
  },
  {
    sex: 'female',
    ageInMonths: '65.5',
    p5: '15.42029408',
    p95: '25.22868007',
  },
  {
    sex: 'female',
    ageInMonths: '66.5',
    p5: '15.56413437',
    p95: '25.5305491',
  },
  {
    sex: 'female',
    ageInMonths: '67.5',
    p5: '15.70843301',
    p95: '25.83466581',
  },
  {
    sex: 'female',
    ageInMonths: '68.5',
    p5: '15.85316397',
    p95: '26.14112991',
  },
  {
    sex: 'female',
    ageInMonths: '69.5',
    p5: '15.99830645',
    p95: '26.45004964',
  },
  {
    sex: 'female',
    ageInMonths: '70.5',
    p5: '16.1438452',
    p95: '26.76154129',
  },
  {
    sex: 'female',
    ageInMonths: '71.5',
    p5: '16.28977109',
    p95: '27.07572865',
  },
  {
    sex: 'female',
    ageInMonths: '72.5',
    p5: '16.43608019',
    p95: '27.39274198',
  },
  {
    sex: 'female',
    ageInMonths: '73.5',
    p5: '16.58277468',
    p95: '27.71271759',
  },
  {
    sex: 'female',
    ageInMonths: '74.5',
    p5: '16.72986243',
    p95: '28.03579694',
  },
  {
    sex: 'female',
    ageInMonths: '75.5',
    p5: '16.87735682',
    p95: '28.36212579',
  },
  {
    sex: 'female',
    ageInMonths: '76.5',
    p5: '17.02527707',
    p95: '28.69185351',
  },
  {
    sex: 'female',
    ageInMonths: '77.5',
    p5: '17.17364841',
    p95: '29.02513239',
  },
  {
    sex: 'female',
    ageInMonths: '78.5',
    p5: '17.32250091',
    p95: '29.36211644',
  },
  {
    sex: 'female',
    ageInMonths: '79.5',
    p5: '17.47186953',
    p95: '29.70296069',
  },
  {
    sex: 'female',
    ageInMonths: '80.5',
    p5: '17.62179544',
    p95: '30.04782073',
  },
  {
    sex: 'female',
    ageInMonths: '81.5',
    p5: '17.77232382',
    p95: '30.39685131',
  },
  {
    sex: 'female',
    ageInMonths: '82.5',
    p5: '17.92350474',
    p95: '30.75020585',
  },
  {
    sex: 'female',
    ageInMonths: '83.5',
    p5: '18.07539265',
    p95: '31.10803553',
  },
  {
    sex: 'female',
    ageInMonths: '84.5',
    p5: '18.2280462',
    p95: '31.47048848',
  },
  {
    sex: 'female',
    ageInMonths: '85.5',
    p5: '18.38152794',
    p95: '31.83770901',
  },
  {
    sex: 'female',
    ageInMonths: '86.5',
    p5: '18.53590513',
    p95: '32.2098371',
  },
  {
    sex: 'female',
    ageInMonths: '87.5',
    p5: '18.69124428',
    p95: '32.58700628',
  },
  {
    sex: 'female',
    ageInMonths: '88.5',
    p5: '18.84762137',
    p95: '32.96934568',
  },
  {
    sex: 'female',
    ageInMonths: '89.5',
    p5: '19.00510849',
    p95: '33.35697585',
  },
  {
    sex: 'female',
    ageInMonths: '90.5',
    p5: '19.16378421',
    p95: '33.75001097',
  },
  {
    sex: 'female',
    ageInMonths: '91.5',
    p5: '19.32372789',
    p95: '34.14855665',
  },
  {
    sex: 'female',
    ageInMonths: '92.5',
    p5: '19.48502077',
    p95: '34.55270981',
  },
  {
    sex: 'female',
    ageInMonths: '93.5',
    p5: '19.64774563',
    p95: '34.96255799',
  },
  {
    sex: 'female',
    ageInMonths: '94.5',
    p5: '19.8119865',
    p95: '35.37817885',
  },
  {
    sex: 'female',
    ageInMonths: '95.5',
    p5: '19.9778266',
    p95: '35.79963916',
  },
  {
    sex: 'female',
    ageInMonths: '96.5',
    p5: '20.14535023',
    p95: '36.2269949',
  },
  {
    sex: 'female',
    ageInMonths: '97.5',
    p5: '20.31464276',
    p95: '36.66029091',
  },
  {
    sex: 'female',
    ageInMonths: '98.5',
    p5: '20.48578791',
    p95: '37.09955982',
  },
  {
    sex: 'female',
    ageInMonths: '99.5',
    p5: '20.65886924',
    p95: '37.54482215',
  },
  {
    sex: 'female',
    ageInMonths: '100.5',
    p5: '20.83396942',
    p95: '37.99608589',
  },
  {
    sex: 'female',
    ageInMonths: '101.5',
    p5: '21.01116968',
    p95: '38.45334608',
  },
  {
    sex: 'female',
    ageInMonths: '102.5',
    p5: '21.19054959',
    p95: '38.91658465',
  },
  {
    sex: 'female',
    ageInMonths: '103.5',
    p5: '21.37218677',
    p95: '39.38577014',
  },
  {
    sex: 'female',
    ageInMonths: '104.5',
    p5: '21.55615653',
    p95: '39.86085756',
  },
  {
    sex: 'female',
    ageInMonths: '105.5',
    p5: '21.74253164',
    p95: '40.3417882',
  },
  {
    sex: 'female',
    ageInMonths: '106.5',
    p5: '21.93138197',
    p95: '40.82848957',
  },
  {
    sex: 'female',
    ageInMonths: '107.5',
    p5: '22.12277423',
    p95: '41.32087531',
  },
  {
    sex: 'female',
    ageInMonths: '108.5',
    p5: '22.31677169',
    p95: '41.8188452',
  },
  {
    sex: 'female',
    ageInMonths: '109.5',
    p5: '22.51343388',
    p95: '42.32228515',
  },
  {
    sex: 'female',
    ageInMonths: '110.5',
    p5: '22.71281638',
    p95: '42.83106725',
  },
  {
    sex: 'female',
    ageInMonths: '111.5',
    p5: '22.91497052',
    p95: '43.34504991',
  },
  {
    sex: 'female',
    ageInMonths: '112.5',
    p5: '23.11994316',
    p95: '43.86407795',
  },
  {
    sex: 'female',
    ageInMonths: '113.5',
    p5: '23.32777646',
    p95: '44.38798278',
  },
  {
    sex: 'female',
    ageInMonths: '114.5',
    p5: '23.53850764',
    p95: '44.91658265',
  },
  {
    sex: 'female',
    ageInMonths: '115.5',
    p5: '23.7521688',
    p95: '45.44968284',
  },
  {
    sex: 'female',
    ageInMonths: '116.5',
    p5: '23.96878672',
    p95: '45.98707597',
  },
  {
    sex: 'female',
    ageInMonths: '117.5',
    p5: '24.18838263',
    p95: '46.52854232',
  },
  {
    sex: 'female',
    ageInMonths: '118.5',
    p5: '24.4109721',
    p95: '47.07385017',
  },
  {
    sex: 'female',
    ageInMonths: '119.5',
    p5: '24.63656488',
    p95: '47.62275619',
  },
  {
    sex: 'female',
    ageInMonths: '120.5',
    p5: '24.86516468',
    p95: '48.17500585',
  },
  {
    sex: 'female',
    ageInMonths: '121.5',
    p5: '25.09676913',
    p95: '48.73033386',
  },
  {
    sex: 'female',
    ageInMonths: '122.5',
    p5: '25.33136962',
    p95: '49.28846466',
  },
  {
    sex: 'female',
    ageInMonths: '123.5',
    p5: '25.56895119',
    p95: '49.84911291',
  },
  {
    sex: 'female',
    ageInMonths: '124.5',
    p5: '25.80949245',
    p95: '50.41198402',
  },
  {
    sex: 'female',
    ageInMonths: '125.5',
    p5: '26.05296553',
    p95: '50.9767747',
  },
  {
    sex: 'female',
    ageInMonths: '126.5',
    p5: '26.29933598',
    p95: '51.54317357',
  },
  {
    sex: 'female',
    ageInMonths: '127.5',
    p5: '26.5485612',
    p95: '52.11086123',
  },
  {
    sex: 'female',
    ageInMonths: '128.5',
    p5: '26.80059725',
    p95: '52.67951305',
  },
  {
    sex: 'female',
    ageInMonths: '129.5',
    p5: '27.05538753',
    p95: '53.2487963',
  },
  {
    sex: 'female',
    ageInMonths: '130.5',
    p5: '27.31287184',
    p95: '53.81837358',
  },
  {
    sex: 'female',
    ageInMonths: '131.5',
    p5: '27.57298031',
    p95: '54.38790173',
  },
  {
    sex: 'female',
    ageInMonths: '132.5',
    p5: '27.83564104',
    p95: '54.95703466',
  },
  {
    sex: 'female',
    ageInMonths: '133.5',
    p5: '28.10077256',
    p95: '55.52542195',
  },
  {
    sex: 'female',
    ageInMonths: '134.5',
    p5: '28.3682877',
    p95: '56.0927106',
  },
  {
    sex: 'female',
    ageInMonths: '135.5',
    p5: '28.63809288',
    p95: '56.65854557',
  },
  {
    sex: 'female',
    ageInMonths: '136.5',
    p5: '28.91008824',
    p95: '57.22257051',
  },
  {
    sex: 'female',
    ageInMonths: '137.5',
    p5: '29.18416775',
    p95: '57.78442851',
  },
  {
    sex: 'female',
    ageInMonths: '138.5',
    p5: '29.46021931',
    p95: '58.34376285',
  },
  {
    sex: 'female',
    ageInMonths: '139.5',
    p5: '29.73812611',
    p95: '58.90021802',
  },
  {
    sex: 'female',
    ageInMonths: '140.5',
    p5: '30.01776074',
    p95: '59.45343918',
  },
  {
    sex: 'female',
    ageInMonths: '141.5',
    p5: '30.29899746',
    p95: '60.00307549',
  },
  {
    sex: 'female',
    ageInMonths: '142.5',
    p5: '30.58170029',
    p95: '60.5487783',
  },
  {
    sex: 'female',
    ageInMonths: '143.5',
    p5: '30.86572924',
    p95: '61.09020319',
  },
  {
    sex: 'female',
    ageInMonths: '144.5',
    p5: '31.15093935',
    p95: '61.62701045',
  },
  {
    sex: 'female',
    ageInMonths: '145.5',
    p5: '31.43718091',
    p95: '62.15886584',
  },
  {
    sex: 'female',
    ageInMonths: '146.5',
    p5: '31.72429973',
    p95: '62.68544133',
  },
  {
    sex: 'female',
    ageInMonths: '147.5',
    p5: '32.01213742',
    p95: '63.20641583',
  },
  {
    sex: 'female',
    ageInMonths: '148.5',
    p5: '32.30053116',
    p95: '63.72147556',
  },
  {
    sex: 'female',
    ageInMonths: '149.5',
    p5: '32.58931625',
    p95: '64.2303163',
  },
  {
    sex: 'female',
    ageInMonths: '150.5',
    p5: '32.87832086',
    p95: '64.73264089',
  },
  {
    sex: 'female',
    ageInMonths: '151.5',
    p5: '33.16737518',
    p95: '65.22816347',
  },
  {
    sex: 'female',
    ageInMonths: '152.5',
    p5: '33.45630184',
    p95: '65.7166078',
  },
  {
    sex: 'female',
    ageInMonths: '153.5',
    p5: '33.74492348',
    p95: '66.19770861',
  },
  {
    sex: 'female',
    ageInMonths: '154.5',
    p5: '34.03306041',
    p95: '66.67121259',
  },
  {
    sex: 'female',
    ageInMonths: '155.5',
    p5: '34.3205311',
    p95: '67.13687835',
  },
  {
    sex: 'female',
    ageInMonths: '156.5',
    p5: '34.60715224',
    p95: '67.59447719',
  },
  {
    sex: 'female',
    ageInMonths: '157.5',
    p5: '34.89273857',
    p95: '68.04379345',
  },
  {
    sex: 'female',
    ageInMonths: '158.5',
    p5: '35.17710718',
    p95: '68.4846261',
  },
  {
    sex: 'female',
    ageInMonths: '159.5',
    p5: '35.46007223',
    p95: '68.91678763',
  },
  {
    sex: 'female',
    ageInMonths: '160.5',
    p5: '35.74144871',
    p95: '69.34010551',
  },
  {
    sex: 'female',
    ageInMonths: '161.5',
    p5: '36.0210521',
    p95: '69.75442235',
  },
  {
    sex: 'female',
    ageInMonths: '162.5',
    p5: '36.29869877',
    p95: '70.15959636',
  },
  {
    sex: 'female',
    ageInMonths: '163.5',
    p5: '36.57420636',
    p95: '70.55550168',
  },
  {
    sex: 'female',
    ageInMonths: '164.5',
    p5: '36.84739419',
    p95: '70.94202872',
  },
  {
    sex: 'female',
    ageInMonths: '165.5',
    p5: '37.11808367',
    p95: '71.31908448',
  },
  {
    sex: 'female',
    ageInMonths: '166.5',
    p5: '37.38609874',
    p95: '71.68659282',
  },
  {
    sex: 'female',
    ageInMonths: '167.5',
    p5: '37.65126622',
    p95: '72.04449469',
  },
  {
    sex: 'female',
    ageInMonths: '168.5',
    p5: '37.91341628',
    p95: '72.39274832',
  },
  {
    sex: 'female',
    ageInMonths: '169.5',
    p5: '38.17238283',
    p95: '72.73132942',
  },
  {
    sex: 'female',
    ageInMonths: '170.5',
    p5: '38.42800396',
    p95: '73.06023127',
  },
  {
    sex: 'female',
    ageInMonths: '171.5',
    p5: '38.68012233',
    p95: '73.37946482',
  },
  {
    sex: 'female',
    ageInMonths: '172.5',
    p5: '38.92858345',
    p95: '73.68905842',
  },
  {
    sex: 'female',
    ageInMonths: '173.5',
    p5: '39.17324412',
    p95: '73.98905915',
  },
  {
    sex: 'female',
    ageInMonths: '174.5',
    p5: '39.41396159',
    p95: '74.27953085',
  },
  {
    sex: 'female',
    ageInMonths: '175.5',
    p5: '39.65060094',
    p95: '74.5605553',
  },
  {
    sex: 'female',
    ageInMonths: '176.5',
    p5: '39.8830339',
    p95: '74.83223179',
  },
  {
    sex: 'female',
    ageInMonths: '177.5',
    p5: '40.11113919',
    p95: '75.09467698',
  },
  {
    sex: 'female',
    ageInMonths: '178.5',
    p5: '40.33480295',
    p95: '75.34802466',
  },
  {
    sex: 'female',
    ageInMonths: '179.5',
    p5: '40.55391906',
    p95: '75.5924255',
  },
  {
    sex: 'female',
    ageInMonths: '180.5',
    p5: '40.76838955',
    p95: '75.82804673',
  },
  {
    sex: 'female',
    ageInMonths: '181.5',
    p5: '40.97812493',
    p95: '76.05507182',
  },
  {
    sex: 'female',
    ageInMonths: '182.5',
    p5: '41.18304453',
    p95: '76.27369999',
  },
  {
    sex: 'female',
    ageInMonths: '183.5',
    p5: '41.3830768',
    p95: '76.48414576',
  },
  {
    sex: 'female',
    ageInMonths: '184.5',
    p5: '41.57815964',
    p95: '76.68663841',
  },
  {
    sex: 'female',
    ageInMonths: '185.5',
    p5: '41.76824065',
    p95: '76.88142138',
  },
  {
    sex: 'female',
    ageInMonths: '186.5',
    p5: '41.95327736',
    p95: '77.06875157',
  },
  {
    sex: 'female',
    ageInMonths: '187.5',
    p5: '42.1332375',
    p95: '77.24889863',
  },
  {
    sex: 'female',
    ageInMonths: '188.5',
    p5: '42.30809914',
    p95: '77.42214413',
  },
  {
    sex: 'female',
    ageInMonths: '189.5',
    p5: '42.4778509',
    p95: '77.58878071',
  },
  {
    sex: 'female',
    ageInMonths: '190.5',
    p5: '42.642492',
    p95: '77.74911109',
  },
  {
    sex: 'female',
    ageInMonths: '191.5',
    p5: '42.80203238',
    p95: '77.90344707',
  },
  {
    sex: 'female',
    ageInMonths: '192.5',
    p5: '42.95649273',
    p95: '78.05210841',
  },
  {
    sex: 'female',
    ageInMonths: '193.5',
    p5: '43.10590449',
    p95: '78.19542171',
  },
  {
    sex: 'female',
    ageInMonths: '194.5',
    p5: '43.25030973',
    p95: '78.33371911',
  },
  {
    sex: 'female',
    ageInMonths: '195.5',
    p5: '43.38976112',
    p95: '78.46733702',
  },
  {
    sex: 'female',
    ageInMonths: '196.5',
    p5: '43.52432169',
    p95: '78.59661472',
  },
  {
    sex: 'female',
    ageInMonths: '197.5',
    p5: '43.65406467',
    p95: '78.72189292',
  },
  {
    sex: 'female',
    ageInMonths: '198.5',
    p5: '43.77907316',
    p95: '78.84351231',
  },
  {
    sex: 'female',
    ageInMonths: '199.5',
    p5: '43.89943983',
    p95: '78.96181194',
  },
  {
    sex: 'female',
    ageInMonths: '200.5',
    p5: '44.01526649',
    p95: '79.07712765',
  },
  {
    sex: 'female',
    ageInMonths: '201.5',
    p5: '44.12666366',
    p95: '79.18979044',
  },
  {
    sex: 'female',
    ageInMonths: '202.5',
    p5: '44.23375003',
    p95: '79.30012477',
  },
  {
    sex: 'female',
    ageInMonths: '203.5',
    p5: '44.33665192',
    p95: '79.40844685',
  },
  {
    sex: 'female',
    ageInMonths: '204.5',
    p5: '44.43550259',
    p95: '79.51506292',
  },
  {
    sex: 'female',
    ageInMonths: '205.5',
    p5: '44.53044156',
    p95: '79.62026752',
  },
  {
    sex: 'female',
    ageInMonths: '206.5',
    p5: '44.62161386',
    p95: '79.72434173',
  },
  {
    sex: 'female',
    ageInMonths: '207.5',
    p5: '44.70916923',
    p95: '79.82755144',
  },
  {
    sex: 'female',
    ageInMonths: '208.5',
    p5: '44.79326117',
    p95: '79.9301456',
  },
  {
    sex: 'female',
    ageInMonths: '209.5',
    p5: '44.8740461',
    p95: '80.03235456',
  },
  {
    sex: 'female',
    ageInMonths: '210.5',
    p5: '44.95168231',
    p95: '80.13438837',
  },
  {
    sex: 'female',
    ageInMonths: '211.5',
    p5: '45.02633189',
    p95: '80.23643485',
  },
  {
    sex: 'female',
    ageInMonths: '212.5',
    p5: '45.09814744',
    p95: '80.33865934',
  },
  {
    sex: 'female',
    ageInMonths: '213.5',
    p5: '45.16728964',
    p95: '80.44120111',
  },
  {
    sex: 'female',
    ageInMonths: '214.5',
    p5: '45.23391322',
    p95: '80.54417335',
  },
  {
    sex: 'female',
    ageInMonths: '215.5',
    p5: '45.29816896',
    p95: '80.64766146',
  },
  {
    sex: 'female',
    ageInMonths: '216.5',
    p5: '45.36020233',
    p95: '80.75172168',
  },
  {
    sex: 'female',
    ageInMonths: '217.5',
    p5: '45.42015206',
    p95: '80.85638',
  },
  {
    sex: 'female',
    ageInMonths: '218.5',
    p5: '45.47814866',
    p95: '80.96163098',
  },
  {
    sex: 'female',
    ageInMonths: '219.5',
    p5: '45.53431283',
    p95: '81.06743678',
  },
  {
    sex: 'female',
    ageInMonths: '220.5',
    p5: '45.58875384',
    p95: '81.17372627',
  },
  {
    sex: 'female',
    ageInMonths: '221.5',
    p5: '45.64156773',
    p95: '81.28039424',
  },
  {
    sex: 'female',
    ageInMonths: '222.5',
    p5: '45.69283549',
    p95: '81.38730069',
  },
  {
    sex: 'female',
    ageInMonths: '223.5',
    p5: '45.74262109',
    p95: '81.49427023',
  },
  {
    sex: 'female',
    ageInMonths: '224.5',
    p5: '45.79096943',
    p95: '81.60109165',
  },
  {
    sex: 'female',
    ageInMonths: '225.5',
    p5: '45.83790409',
    p95: '81.70751748',
  },
  {
    sex: 'female',
    ageInMonths: '226.5',
    p5: '45.88342504',
    p95: '81.8132637',
  },
  {
    sex: 'female',
    ageInMonths: '227.5',
    p5: '45.92750914',
    p95: '81.91800816',
  },
  {
    sex: 'female',
    ageInMonths: '228.5',
    p5: '45.97009344',
    p95: '82.02139464',
  },
  {
    sex: 'female',
    ageInMonths: '229.5',
    p5: '46.01109826',
    p95: '82.12302792',
  },
  {
    sex: 'female',
    ageInMonths: '230.5',
    p5: '46.05040055',
    p95: '82.22248225',
  },
  {
    sex: 'female',
    ageInMonths: '231.5',
    p5: '46.08784264',
    p95: '82.3192791',
  },
  {
    sex: 'female',
    ageInMonths: '232.5',
    p5: '46.12322421',
    p95: '82.41291688',
  },
  {
    sex: 'female',
    ageInMonths: '233.5',
    p5: '46.15630107',
    p95: '82.50285304',
  },
  {
    sex: 'female',
    ageInMonths: '234.5',
    p5: '46.18678082',
    p95: '82.58850833',
  },
  {
    sex: 'female',
    ageInMonths: '235.5',
    p5: '46.21431895',
    p95: '82.66926695',
  },
  {
    sex: 'female',
    ageInMonths: '236.5',
    p5: '46.23851477',
    p95: '82.74447678',
  },
  {
    sex: 'female',
    ageInMonths: '237.5',
    p5: '46.2589107',
    p95: '82.81344962',
  },
  {
    sex: 'female',
    ageInMonths: '238.5',
    p5: '46.27497563',
    p95: '82.87546122',
  },
  {
    sex: 'female',
    ageInMonths: '239.5',
    p5: '46.28611635',
    p95: '82.92975179',
  },
  {
    sex: 'female',
    ageInMonths: '240',
    p5: '46.28963394',
    p95: '82.95375457',
  },
];

const heightPercentilesRaw = [
  {
    sex: 'male',
    ageInMonths: '24',
    p5: '80.72977321',
    p95: '92.19687928',
  },
  {
    sex: 'male',
    ageInMonths: '24.5',
    p5: '81.08868489',
    p95: '92.63176749',
  },
  {
    sex: 'male',
    ageInMonths: '25.5',
    p5: '81.83445202',
    p95: '93.53406648',
  },
  {
    sex: 'male',
    ageInMonths: '26.5',
    p5: '82.56406112',
    p95: '94.40884914',
  },
  {
    sex: 'male',
    ageInMonths: '27.5',
    p5: '83.27898582',
    p95: '95.25754106',
  },
  {
    sex: 'male',
    ageInMonths: '28.5',
    p5: '83.98045262',
    p95: '96.08148848',
  },
  {
    sex: 'male',
    ageInMonths: '29.5',
    p5: '84.66948449',
    p95: '96.88197981',
  },
  {
    sex: 'male',
    ageInMonths: '30.5',
    p5: '85.3469433',
    p95: '97.66026663',
  },
  {
    sex: 'male',
    ageInMonths: '31.5',
    p5: '86.01356554',
    p95: '98.4175791',
  },
  {
    sex: 'male',
    ageInMonths: '32.5',
    p5: '86.66999332',
    p95: '99.15513792',
  },
  {
    sex: 'male',
    ageInMonths: '33.5',
    p5: '87.31680155',
    p95: '99.87416352',
  },
  {
    sex: 'male',
    ageInMonths: '34.5',
    p5: '87.95452162',
    p95: '100.5758831',
  },
  {
    sex: 'male',
    ageInMonths: '35.5',
    p5: '88.58366128',
    p95: '101.2615351',
  },
  {
    sex: 'male',
    ageInMonths: '36.5',
    p5: '89.20472611',
    p95: '101.9323762',
  },
  {
    sex: 'male',
    ageInMonths: '37.5',
    p5: '89.77301106',
    p95: '102.5930445',
  },
  {
    sex: 'male',
    ageInMonths: '38.5',
    p5: '90.33305814',
    p95: '103.2470198',
  },
  {
    sex: 'male',
    ageInMonths: '39.5',
    p5: '90.88532031',
    p95: '103.8948257',
  },
  {
    sex: 'male',
    ageInMonths: '40.5',
    p5: '91.43025486',
    p95: '104.5369608',
  },
  {
    sex: 'male',
    ageInMonths: '41.5',
    p5: '91.96832362',
    p95: '105.1739016',
  },
  {
    sex: 'male',
    ageInMonths: '42.5',
    p5: '92.4999858',
    p95: '105.8060983',
  },
  {
    sex: 'male',
    ageInMonths: '43.5',
    p5: '93.02569976',
    p95: '106.4339786',
  },
  {
    sex: 'male',
    ageInMonths: '44.5',
    p5: '93.54591978',
    p95: '107.0579468',
  },
  {
    sex: 'male',
    ageInMonths: '45.5',
    p5: '94.06109422',
    p95: '107.6783842',
  },
  {
    sex: 'male',
    ageInMonths: '46.5',
    p5: '94.57166376',
    p95: '108.2956497',
  },
  {
    sex: 'male',
    ageInMonths: '47.5',
    p5: '95.07805975',
    p95: '108.9100797',
  },
  {
    sex: 'male',
    ageInMonths: '48.5',
    p5: '95.58070273',
    p95: '109.5219891',
  },
  {
    sex: 'male',
    ageInMonths: '49.5',
    p5: '96.08000091',
    p95: '110.1316713',
  },
  {
    sex: 'male',
    ageInMonths: '50.5',
    p5: '96.57634888',
    p95: '110.7393989',
  },
  {
    sex: 'male',
    ageInMonths: '51.5',
    p5: '97.07012724',
    p95: '111.3454248',
  },
  {
    sex: 'male',
    ageInMonths: '52.5',
    p5: '97.56169654',
    p95: '111.9499779',
  },
  {
    sex: 'male',
    ageInMonths: '53.5',
    p5: '98.05140652',
    p95: '112.5532737',
  },
  {
    sex: 'male',
    ageInMonths: '54.5',
    p5: '98.53958366',
    p95: '113.1555037',
  },
  {
    sex: 'male',
    ageInMonths: '55.5',
    p5: '99.026537',
    p95: '113.7568423',
  },
  {
    sex: 'male',
    ageInMonths: '56.5',
    p5: '99.51255522',
    p95: '114.3574452',
  },
  {
    sex: 'male',
    ageInMonths: '57.5',
    p5: '99.99790605',
    p95: '114.9574502',
  },
  {
    sex: 'male',
    ageInMonths: '58.5',
    p5: '100.4828356',
    p95: '115.5569776',
  },
  {
    sex: 'male',
    ageInMonths: '59.5',
    p5: '100.9675675',
    p95: '116.1561304',
  },
  {
    sex: 'male',
    ageInMonths: '60.5',
    p5: '101.4523027',
    p95: '116.7549954',
  },
  {
    sex: 'male',
    ageInMonths: '61.5',
    p5: '101.9372185',
    p95: '117.3536426',
  },
  {
    sex: 'male',
    ageInMonths: '62.5',
    p5: '102.4224687',
    p95: '117.9521268',
  },
  {
    sex: 'male',
    ageInMonths: '63.5',
    p5: '102.908183',
    p95: '118.5504872',
  },
  {
    sex: 'male',
    ageInMonths: '64.5',
    p5: '103.3944666',
    p95: '119.1487482',
  },
  {
    sex: 'male',
    ageInMonths: '65.5',
    p5: '103.8814006',
    p95: '119.7469201',
  },
  {
    sex: 'male',
    ageInMonths: '66.5',
    p5: '104.3690418',
    p95: '120.3449993',
  },
  {
    sex: 'male',
    ageInMonths: '67.5',
    p5: '104.8574227',
    p95: '120.9429688',
  },
  {
    sex: 'male',
    ageInMonths: '68.5',
    p5: '105.3465519',
    p95: '121.540799',
  },
  {
    sex: 'male',
    ageInMonths: '69.5',
    p5: '105.8364145',
    p95: '122.1384479',
  },
  {
    sex: 'male',
    ageInMonths: '70.5',
    p5: '106.3269721',
    p95: '122.7358617',
  },
  {
    sex: 'male',
    ageInMonths: '71.5',
    p5: '106.8181654',
    p95: '123.3329768',
  },
  {
    sex: 'male',
    ageInMonths: '72.5',
    p5: '107.3099116',
    p95: '123.9297176',
  },
  {
    sex: 'male',
    ageInMonths: '73.5',
    p5: '107.8021076',
    p95: '124.5259991',
  },
  {
    sex: 'male',
    ageInMonths: '74.5',
    p5: '108.2946307',
    p95: '125.1217272',
  },
  {
    sex: 'male',
    ageInMonths: '75.5',
    p5: '108.7873391',
    p95: '125.7167992',
  },
  {
    sex: 'male',
    ageInMonths: '76.5',
    p5: '109.2800738',
    p95: '126.3111047',
  },
  {
    sex: 'male',
    ageInMonths: '77.5',
    p5: '109.7726591',
    p95: '126.9045258',
  },
  {
    sex: 'male',
    ageInMonths: '78.5',
    p5: '110.2649049',
    p95: '127.4969382',
  },
  {
    sex: 'male',
    ageInMonths: '79.5',
    p5: '110.7566073',
    p95: '128.0882119',
  },
  {
    sex: 'male',
    ageInMonths: '80.5',
    p5: '111.247551',
    p95: '128.6782115',
  },
  {
    sex: 'male',
    ageInMonths: '81.5',
    p5: '111.7375104',
    p95: '129.2667977',
  },
  {
    sex: 'male',
    ageInMonths: '82.5',
    p5: '112.2262515',
    p95: '129.8538272',
  },
  {
    sex: 'male',
    ageInMonths: '83.5',
    p5: '112.7135338',
    p95: '130.4391542',
  },
  {
    sex: 'male',
    ageInMonths: '84.5',
    p5: '113.1991118',
    p95: '131.0226304',
  },
  {
    sex: 'male',
    ageInMonths: '85.5',
    p5: '113.6827373',
    p95: '131.6041067',
  },
  {
    sex: 'male',
    ageInMonths: '86.5',
    p5: '114.1641607',
    p95: '132.183433',
  },
  {
    sex: 'male',
    ageInMonths: '87.5',
    p5: '114.6431334',
    p95: '132.7604599',
  },
  {
    sex: 'male',
    ageInMonths: '88.5',
    p5: '115.1194078',
    p95: '133.335037',
  },
  {
    sex: 'male',
    ageInMonths: '89.5',
    p5: '115.5927447',
    p95: '133.9070206',
  },
  {
    sex: 'male',
    ageInMonths: '90.5',
    p5: '116.0629074',
    p95: '134.4762655',
  },
  {
    sex: 'male',
    ageInMonths: '91.5',
    p5: '116.5296686',
    p95: '135.0426312',
  },
  {
    sex: 'male',
    ageInMonths: '92.5',
    p5: '116.9928104',
    p95: '135.6059815',
  },
  {
    sex: 'male',
    ageInMonths: '93.5',
    p5: '117.4521263',
    p95: '136.1661852',
  },
  {
    sex: 'male',
    ageInMonths: '94.5',
    p5: '117.9074226',
    p95: '136.7231173',
  },
  {
    sex: 'male',
    ageInMonths: '95.5',
    p5: '118.3585201',
    p95: '137.2766592',
  },
  {
    sex: 'male',
    ageInMonths: '96.5',
    p5: '118.8052553',
    p95: '137.8267001',
  },
  {
    sex: 'male',
    ageInMonths: '97.5',
    p5: '119.2474816',
    p95: '138.3731376',
  },
  {
    sex: 'male',
    ageInMonths: '98.5',
    p5: '119.6850711',
    p95: '138.9158785',
  },
  {
    sex: 'male',
    ageInMonths: '99.5',
    p5: '120.1179149',
    p95: '139.4548395',
  },
  {
    sex: 'male',
    ageInMonths: '100.5',
    p5: '120.5459248',
    p95: '139.9899485',
  },
  {
    sex: 'male',
    ageInMonths: '101.5',
    p5: '120.9690339',
    p95: '140.5211451',
  },
  {
    sex: 'male',
    ageInMonths: '102.5',
    p5: '121.3871973',
    p95: '141.0483813',
  },
  {
    sex: 'male',
    ageInMonths: '103.5',
    p5: '121.8003934',
    p95: '141.5716229',
  },
  {
    sex: 'male',
    ageInMonths: '104.5',
    p5: '122.2086239',
    p95: '142.0908498',
  },
  {
    sex: 'male',
    ageInMonths: '105.5',
    p5: '122.6119145',
    p95: '142.6060571',
  },
  {
    sex: 'male',
    ageInMonths: '106.5',
    p5: '123.0103156',
    p95: '143.1172562',
  },
  {
    sex: 'male',
    ageInMonths: '107.5',
    p5: '123.4039024',
    p95: '143.6244753',
  },
  {
    sex: 'male',
    ageInMonths: '108.5',
    p5: '123.7927752',
    p95: '144.1277605',
  },
  {
    sex: 'male',
    ageInMonths: '109.5',
    p5: '124.1770596',
    p95: '144.6271767',
  },
  {
    sex: 'male',
    ageInMonths: '110.5',
    p5: '124.5569064',
    p95: '145.1228083',
  },
  {
    sex: 'male',
    ageInMonths: '111.5',
    p5: '124.9324922',
    p95: '145.6147602',
  },
  {
    sex: 'male',
    ageInMonths: '112.5',
    p5: '125.3040185',
    p95: '146.103159',
  },
  {
    sex: 'male',
    ageInMonths: '113.5',
    p5: '125.6717122',
    p95: '146.5881531',
  },
  {
    sex: 'male',
    ageInMonths: '114.5',
    p5: '126.035825',
    p95: '147.0699143',
  },
  {
    sex: 'male',
    ageInMonths: '115.5',
    p5: '126.3966334',
    p95: '147.5486382',
  },
  {
    sex: 'male',
    ageInMonths: '116.5',
    p5: '126.7544381',
    p95: '148.0245452',
  },
  {
    sex: 'male',
    ageInMonths: '117.5',
    p5: '127.1095636',
    p95: '148.4978811',
  },
  {
    sex: 'male',
    ageInMonths: '118.5',
    p5: '127.4623576',
    p95: '148.9689178',
  },
  {
    sex: 'male',
    ageInMonths: '119.5',
    p5: '127.8131904',
    p95: '149.4379538',
  },
  {
    sex: 'male',
    ageInMonths: '120.5',
    p5: '128.1624542',
    p95: '149.9053151',
  },
  {
    sex: 'male',
    ageInMonths: '121.5',
    p5: '128.5105623',
    p95: '150.3713549',
  },
  {
    sex: 'male',
    ageInMonths: '122.5',
    p5: '128.857948',
    p95: '150.8364543',
  },
  {
    sex: 'male',
    ageInMonths: '123.5',
    p5: '129.2050634',
    p95: '151.3010223',
  },
  {
    sex: 'male',
    ageInMonths: '124.5',
    p5: '129.5523785',
    p95: '151.7654951',
  },
  {
    sex: 'male',
    ageInMonths: '125.5',
    p5: '129.9003795',
    p95: '152.2303363',
  },
  {
    sex: 'male',
    ageInMonths: '126.5',
    p5: '130.2495672',
    p95: '152.6960355',
  },
  {
    sex: 'male',
    ageInMonths: '127.5',
    p5: '130.6004555',
    p95: '153.1631074',
  },
  {
    sex: 'male',
    ageInMonths: '128.5',
    p5: '130.9535693',
    p95: '153.6320904',
  },
  {
    sex: 'male',
    ageInMonths: '129.5',
    p5: '131.309442',
    p95: '154.103544',
  },
  {
    sex: 'male',
    ageInMonths: '130.5',
    p5: '131.6686134',
    p95: '154.5780465',
  },
  {
    sex: 'male',
    ageInMonths: '131.5',
    p5: '132.031627',
    p95: '155.0561919',
  },
  {
    sex: 'male',
    ageInMonths: '132.5',
    p5: '132.3990267',
    p95: '155.5385858',
  },
  {
    sex: 'male',
    ageInMonths: '133.5',
    p5: '132.771354',
    p95: '156.0258407',
  },
  {
    sex: 'male',
    ageInMonths: '134.5',
    p5: '133.1491442',
    p95: '156.5185711',
  },
  {
    sex: 'male',
    ageInMonths: '135.5',
    p5: '133.5329226',
    p95: '157.0173867',
  },
  {
    sex: 'male',
    ageInMonths: '136.5',
    p5: '133.9232006',
    p95: '157.522886',
  },
  {
    sex: 'male',
    ageInMonths: '137.5',
    p5: '134.3204714',
    p95: '158.0356481',
  },
  {
    sex: 'male',
    ageInMonths: '138.5',
    p5: '134.7252055',
    p95: '158.5562242',
  },
  {
    sex: 'male',
    ageInMonths: '139.5',
    p5: '135.1378458',
    p95: '159.085128',
  },
  {
    sex: 'male',
    ageInMonths: '140.5',
    p5: '135.5588028',
    p95: '159.622826',
  },
  {
    sex: 'male',
    ageInMonths: '141.5',
    p5: '135.9884501',
    p95: '160.1697263',
  },
  {
    sex: 'male',
    ageInMonths: '142.5',
    p5: '136.4271185',
    p95: '160.7261679',
  },
  {
    sex: 'male',
    ageInMonths: '143.5',
    p5: '136.8750919',
    p95: '161.2924091',
  },
  {
    sex: 'male',
    ageInMonths: '144.5',
    p5: '137.3326017',
    p95: '161.8686162',
  },
  {
    sex: 'male',
    ageInMonths: '145.5',
    p5: '137.7998222',
    p95: '162.4548526',
  },
  {
    sex: 'male',
    ageInMonths: '146.5',
    p5: '138.2768661',
    p95: '163.0510679',
  },
  {
    sex: 'male',
    ageInMonths: '147.5',
    p5: '138.7637799',
    p95: '163.657089',
  },
  {
    sex: 'male',
    ageInMonths: '148.5',
    p5: '139.2605402',
    p95: '164.2726114',
  },
  {
    sex: 'male',
    ageInMonths: '149.5',
    p5: '139.7670498',
    p95: '164.897193',
  },
  {
    sex: 'male',
    ageInMonths: '150.5',
    p5: '140.2831346',
    p95: '165.5302497',
  },
  {
    sex: 'male',
    ageInMonths: '151.5',
    p5: '140.8085414',
    p95: '166.1710534',
  },
  {
    sex: 'male',
    ageInMonths: '152.5',
    p5: '141.3429356',
    p95: '166.8187329',
  },
  {
    sex: 'male',
    ageInMonths: '153.5',
    p5: '141.8859002',
    p95: '167.4722776',
  },
  {
    sex: 'male',
    ageInMonths: '154.5',
    p5: '142.4369354',
    p95: '168.1305444',
  },
  {
    sex: 'male',
    ageInMonths: '155.5',
    p5: '142.9954591',
    p95: '168.7922681',
  },
  {
    sex: 'male',
    ageInMonths: '156.5',
    p5: '143.5608087',
    p95: '169.4560742',
  },
  {
    sex: 'male',
    ageInMonths: '157.5',
    p5: '144.1322433',
    p95: '170.1204959',
  },
  {
    sex: 'male',
    ageInMonths: '158.5',
    p5: '144.7089466',
    p95: '170.7839909',
  },
  {
    sex: 'male',
    ageInMonths: '159.5',
    p5: '145.2900346',
    p95: '171.444966',
  },
  {
    sex: 'male',
    ageInMonths: '160.5',
    p5: '145.8745579',
    p95: '172.1017957',
  },
  {
    sex: 'male',
    ageInMonths: '161.5',
    p5: '146.4615117',
    p95: '172.7528491',
  },
  {
    sex: 'male',
    ageInMonths: '162.5',
    p5: '147.0498421',
    p95: '173.3965112',
  },
  {
    sex: 'male',
    ageInMonths: '163.5',
    p5: '147.6384567',
    p95: '174.0312083',
  },
  {
    sex: 'male',
    ageInMonths: '164.5',
    p5: '148.226234',
    p95: '174.6554295',
  },
  {
    sex: 'male',
    ageInMonths: '165.5',
    p5: '148.8120346',
    p95: '175.2677481',
  },
  {
    sex: 'male',
    ageInMonths: '166.5',
    p5: '149.394712',
    p95: '175.8668393',
  },
  {
    sex: 'male',
    ageInMonths: '167.5',
    p5: '149.9731226',
    p95: '176.4514947',
  },
  {
    sex: 'male',
    ageInMonths: '168.5',
    p5: '150.5461431',
    p95: '177.0206409',
  },
  {
    sex: 'male',
    ageInMonths: '169.5',
    p5: '151.1126739',
    p95: '177.5733406',
  },
  {
    sex: 'male',
    ageInMonths: '170.5',
    p5: '151.6716544',
    p95: '178.1088034',
  },
  {
    sex: 'male',
    ageInMonths: '171.5',
    p5: '152.2220718',
    p95: '178.6263873',
  },
  {
    sex: 'male',
    ageInMonths: '172.5',
    p5: '152.7629701',
    p95: '179.1255987',
  },
  {
    sex: 'male',
    ageInMonths: '173.5',
    p5: '153.2934582',
    p95: '179.6060885',
  },
  {
    sex: 'male',
    ageInMonths: '174.5',
    p5: '153.8127163',
    p95: '180.0676464',
  },
  {
    sex: 'male',
    ageInMonths: '175.5',
    p5: '154.3200013',
    p95: '180.5101936',
  },
  {
    sex: 'male',
    ageInMonths: '176.5',
    p5: '154.814651',
    p95: '180.9337725',
  },
  {
    sex: 'male',
    ageInMonths: '177.5',
    p5: '155.2960861',
    p95: '181.3385364',
  },
  {
    sex: 'male',
    ageInMonths: '178.5',
    p5: '155.7638123',
    p95: '181.7247376',
  },
  {
    sex: 'male',
    ageInMonths: '179.5',
    p5: '156.2174196',
    p95: '182.0927156',
  },
  {
    sex: 'male',
    ageInMonths: '180.5',
    p5: '156.6565818',
    p95: '182.4428851',
  },
  {
    sex: 'male',
    ageInMonths: '181.5',
    p5: '157.0810539',
    p95: '182.7757235',
  },
  {
    sex: 'male',
    ageInMonths: '182.5',
    p5: '157.4906696',
    p95: '183.09176',
  },
  {
    sex: 'male',
    ageInMonths: '183.5',
    p5: '157.8853369',
    p95: '183.3915648',
  },
  {
    sex: 'male',
    ageInMonths: '184.5',
    p5: '158.2650343',
    p95: '183.6757386',
  },
  {
    sex: 'male',
    ageInMonths: '185.5',
    p5: '158.6298055',
    p95: '183.9449038',
  },
  {
    sex: 'male',
    ageInMonths: '186.5',
    p5: '158.9797544',
    p95: '184.1996965',
  },
  {
    sex: 'male',
    ageInMonths: '187.5',
    p5: '159.31504',
    p95: '184.4407585',
  },
  {
    sex: 'male',
    ageInMonths: '188.5',
    p5: '159.6358703',
    p95: '184.6687321',
  },
  {
    sex: 'male',
    ageInMonths: '189.5',
    p5: '159.9424968',
    p95: '184.8842531',
  },
  {
    sex: 'male',
    ageInMonths: '190.5',
    p5: '160.2352102',
    p95: '185.0879485',
  },
  {
    sex: 'male',
    ageInMonths: '191.5',
    p5: '160.5143338',
    p95: '185.2804307',
  },
  {
    sex: 'male',
    ageInMonths: '192.5',
    p5: '160.7802183',
    p95: '185.4622948',
  },
  {
    sex: 'male',
    ageInMonths: '193.5',
    p5: '161.0332391',
    p95: '185.6341183',
  },
  {
    sex: 'male',
    ageInMonths: '194.5',
    p5: '161.2737894',
    p95: '185.7964565',
  },
  {
    sex: 'male',
    ageInMonths: '195.5',
    p5: '161.5022772',
    p95: '185.949843',
  },
  {
    sex: 'male',
    ageInMonths: '196.5',
    p5: '161.7191211',
    p95: '186.0947883',
  },
  {
    sex: 'male',
    ageInMonths: '197.5',
    p5: '161.9247473',
    p95: '186.2317794',
  },
  {
    sex: 'male',
    ageInMonths: '198.5',
    p5: '162.1195857',
    p95: '186.3612801',
  },
  {
    sex: 'male',
    ageInMonths: '199.5',
    p5: '162.3040676',
    p95: '186.4837302',
  },
  {
    sex: 'male',
    ageInMonths: '200.5',
    p5: '162.4786229',
    p95: '186.5995468',
  },
  {
    sex: 'male',
    ageInMonths: '201.5',
    p5: '162.643678',
    p95: '186.7091242',
  },
  {
    sex: 'male',
    ageInMonths: '202.5',
    p5: '162.7996536',
    p95: '186.8128348',
  },
  {
    sex: 'male',
    ageInMonths: '203.5',
    p5: '162.9469636',
    p95: '186.9110296',
  },
  {
    sex: 'male',
    ageInMonths: '204.5',
    p5: '163.0860132',
    p95: '187.0040394',
  },
  {
    sex: 'male',
    ageInMonths: '205.5',
    p5: '163.2171976',
    p95: '187.0921753',
  },
  {
    sex: 'male',
    ageInMonths: '206.5',
    p5: '163.3409016',
    p95: '187.1757295',
  },
  {
    sex: 'male',
    ageInMonths: '207.5',
    p5: '163.4574984',
    p95: '187.2549767',
  },
  {
    sex: 'male',
    ageInMonths: '208.5',
    p5: '163.5673489',
    p95: '187.3301745',
  },
  {
    sex: 'male',
    ageInMonths: '209.5',
    p5: '163.6708019',
    p95: '187.4015645',
  },
  {
    sex: 'male',
    ageInMonths: '210.5',
    p5: '163.7681929',
    p95: '187.4693732',
  },
  {
    sex: 'male',
    ageInMonths: '211.5',
    p5: '163.8598446',
    p95: '187.5338128',
  },
  {
    sex: 'male',
    ageInMonths: '212.5',
    p5: '163.9460665',
    p95: '187.5950821',
  },
  {
    sex: 'male',
    ageInMonths: '213.5',
    p5: '164.027155',
    p95: '187.6533672',
  },
  {
    sex: 'male',
    ageInMonths: '214.5',
    p5: '164.1033935',
    p95: '187.7088422',
  },
  {
    sex: 'male',
    ageInMonths: '215.5',
    p5: '164.1750527',
    p95: '187.7616702',
  },
  {
    sex: 'male',
    ageInMonths: '216.5',
    p5: '164.2423904',
    p95: '187.8120038',
  },
  {
    sex: 'male',
    ageInMonths: '217.5',
    p5: '164.3056523',
    p95: '187.8599859',
  },
  {
    sex: 'male',
    ageInMonths: '218.5',
    p5: '164.365072',
    p95: '187.9057499',
  },
  {
    sex: 'male',
    ageInMonths: '219.5',
    p5: '164.4208714',
    p95: '187.9494211',
  },
  {
    sex: 'male',
    ageInMonths: '220.5',
    p5: '164.473261',
    p95: '187.9911165',
  },
  {
    sex: 'male',
    ageInMonths: '221.5',
    p5: '164.5224406',
    p95: '188.0309455',
  },
  {
    sex: 'male',
    ageInMonths: '222.5',
    p5: '164.5685992',
    p95: '188.0690108',
  },
  {
    sex: 'male',
    ageInMonths: '223.5',
    p5: '164.6119158',
    p95: '188.1054085',
  },
  {
    sex: 'male',
    ageInMonths: '224.5',
    p5: '164.6525596',
    p95: '188.1402284',
  },
  {
    sex: 'male',
    ageInMonths: '225.5',
    p5: '164.6906907',
    p95: '188.1735549',
  },
  {
    sex: 'male',
    ageInMonths: '226.5',
    p5: '164.72646',
    p95: '188.2054669',
  },
  {
    sex: 'male',
    ageInMonths: '227.5',
    p5: '164.7600102',
    p95: '188.2360386',
  },
  {
    sex: 'male',
    ageInMonths: '228.5',
    p5: '164.7914756',
    p95: '188.2653392',
  },
  {
    sex: 'male',
    ageInMonths: '229.5',
    p5: '164.8209832',
    p95: '188.293434',
  },
  {
    sex: 'male',
    ageInMonths: '230.5',
    p5: '164.8486523',
    p95: '188.3203841',
  },
  {
    sex: 'male',
    ageInMonths: '231.5',
    p5: '164.8745955',
    p95: '188.3462469',
  },
  {
    sex: 'male',
    ageInMonths: '232.5',
    p5: '164.8989187',
    p95: '188.3710763',
  },
  {
    sex: 'male',
    ageInMonths: '233.5',
    p5: '164.9217215',
    p95: '188.394923',
  },
  {
    sex: 'male',
    ageInMonths: '234.5',
    p5: '164.9430978',
    p95: '188.4178347',
  },
  {
    sex: 'male',
    ageInMonths: '235.5',
    p5: '164.9631357',
    p95: '188.4398562',
  },
  {
    sex: 'male',
    ageInMonths: '236.5',
    p5: '164.9819181',
    p95: '188.4610297',
  },
  {
    sex: 'male',
    ageInMonths: '237.5',
    p5: '164.9995229',
    p95: '188.481395',
  },
  {
    sex: 'male',
    ageInMonths: '238.5',
    p5: '165.0160233',
    p95: '188.5009894',
  },
  {
    sex: 'male',
    ageInMonths: '239.5',
    p5: '165.031488',
    p95: '188.5198484',
  },
  {
    sex: 'male',
    ageInMonths: '240',
    p5: '165.0388523',
    p95: '188.5290125',
  },
  {
    sex: 'female',
    ageInMonths: '24',
    p5: '79.25981989',
    p95: '90.66354871',
  },
  {
    sex: 'female',
    ageInMonths: '24.5',
    p5: '79.64776859',
    p95: '91.12706971',
  },
  {
    sex: 'female',
    ageInMonths: '25.5',
    p5: '80.44225735',
    p95: '92.12167631',
  },
  {
    sex: 'female',
    ageInMonths: '26.5',
    p5: '81.22666181',
    p95: '93.08254082',
  },
  {
    sex: 'female',
    ageInMonths: '27.5',
    p5: '81.99539596',
    p95: '94.00872819',
  },
  {
    sex: 'female',
    ageInMonths: '28.5',
    p5: '82.74410888',
    p95: '94.89974364',
  },
  {
    sex: 'female',
    ageInMonths: '29.5',
    p5: '83.46956585',
    p95: '95.75551171',
  },
  {
    sex: 'female',
    ageInMonths: '30.5',
    p5: '84.16952943',
    p95: '96.57635253',
  },
  {
    sex: 'female',
    ageInMonths: '31.5',
    p5: '84.84263937',
    p95: '97.36295103',
  },
  {
    sex: 'female',
    ageInMonths: '32.5',
    p5: '85.48829708',
    p95: '98.11632342',
  },
  {
    sex: 'female',
    ageInMonths: '33.5',
    p5: '86.10655881',
    p95: '98.83778417',
  },
  {
    sex: 'female',
    ageInMonths: '34.5',
    p5: '86.69803144',
    p95: '99.52890698',
  },
  {
    sex: 'female',
    ageInMonths: '35.5',
    p5: '87.26378819',
    p95: '100.191497',
  },
  {
    sex: 'female',
    ageInMonths: '36.5',
    p5: '87.80528157',
    p95: '100.8275527',
  },
  {
    sex: 'female',
    ageInMonths: '37.5',
    p5: '88.34236213',
    p95: '101.4726459',
  },
  {
    sex: 'female',
    ageInMonths: '38.5',
    p5: '88.87255864',
    p95: '102.112939',
  },
  {
    sex: 'female',
    ageInMonths: '39.5',
    p5: '89.39733426',
    p95: '102.7494191',
  },
  {
    sex: 'female',
    ageInMonths: '40.5',
    p5: '89.91797078',
    p95: '103.3829734',
  },
  {
    sex: 'female',
    ageInMonths: '41.5',
    p5: '90.43558554',
    p95: '104.0143944',
  },
  {
    sex: 'female',
    ageInMonths: '42.5',
    p5: '90.95114701',
    p95: '104.6443859',
  },
  {
    sex: 'female',
    ageInMonths: '43.5',
    p5: '91.4654891',
    p95: '105.2735676',
  },
  {
    sex: 'female',
    ageInMonths: '44.5',
    p5: '91.97932415',
    p95: '105.9024803',
  },
  {
    sex: 'female',
    ageInMonths: '45.5',
    p5: '92.49325483',
    p95: '106.5315907',
  },
  {
    sex: 'female',
    ageInMonths: '46.5',
    p5: '93.00778484',
    p95: '107.161296',
  },
  {
    sex: 'female',
    ageInMonths: '47.5',
    p5: '93.52332863',
    p95: '107.7919282',
  },
  {
    sex: 'female',
    ageInMonths: '48.5',
    p5: '94.04022021',
    p95: '108.4237579',
  },
  {
    sex: 'female',
    ageInMonths: '49.5',
    p5: '94.55872109',
    p95: '109.0569988',
  },
  {
    sex: 'female',
    ageInMonths: '50.5',
    p5: '95.07902737',
    p95: '109.6918111',
  },
  {
    sex: 'female',
    ageInMonths: '51.5',
    p5: '95.60127628',
    p95: '110.3283052',
  },
  {
    sex: 'female',
    ageInMonths: '52.5',
    p5: '96.12555202',
    p95: '110.9665451',
  },
  {
    sex: 'female',
    ageInMonths: '53.5',
    p5: '96.65189097',
    p95: '111.6065515',
  },
  {
    sex: 'female',
    ageInMonths: '54.5',
    p5: '97.18028656',
    p95: '112.2483051',
  },
  {
    sex: 'female',
    ageInMonths: '55.5',
    p5: '97.7106936',
    p95: '112.8917498',
  },
  {
    sex: 'female',
    ageInMonths: '56.5',
    p5: '98.24303219',
    p95: '113.536795',
  },
  {
    sex: 'female',
    ageInMonths: '57.5',
    p5: '98.77719141',
    p95: '114.1833188',
  },
  {
    sex: 'female',
    ageInMonths: '58.5',
    p5: '99.31303257',
    p95: '114.8311708',
  },
  {
    sex: 'female',
    ageInMonths: '59.5',
    p5: '99.85039229',
    p95: '115.4801741',
  },
  {
    sex: 'female',
    ageInMonths: '60.5',
    p5: '100.3890853',
    p95: '116.1301284',
  },
  {
    sex: 'female',
    ageInMonths: '61.5',
    p5: '100.9289069',
    p95: '116.780812',
  },
  {
    sex: 'female',
    ageInMonths: '62.5',
    p5: '101.4696357',
    p95: '117.4319846',
  },
  {
    sex: 'female',
    ageInMonths: '63.5',
    p5: '102.0110354',
    p95: '118.0833889',
  },
  {
    sex: 'female',
    ageInMonths: '64.5',
    p5: '102.5528574',
    p95: '118.7347537',
  },
  {
    sex: 'female',
    ageInMonths: '65.5',
    p5: '103.0948423',
    p95: '119.3857953',
  },
  {
    sex: 'female',
    ageInMonths: '66.5',
    p5: '103.6367221',
    p95: '120.03622',
  },
  {
    sex: 'female',
    ageInMonths: '67.5',
    p5: '104.1782217',
    p95: '120.685726',
  },
  {
    sex: 'female',
    ageInMonths: '68.5',
    p5: '104.7190606',
    p95: '121.3340057',
  },
  {
    sex: 'female',
    ageInMonths: '69.5',
    p5: '105.258955',
    p95: '121.9807474',
  },
  {
    sex: 'female',
    ageInMonths: '70.5',
    p5: '105.797617',
    p95: '122.6256361',
  },
  {
    sex: 'female',
    ageInMonths: '71.5',
    p5: '106.3347618',
    p95: '123.2683596',
  },
  {
    sex: 'female',
    ageInMonths: '72.5',
    p5: '106.8701003',
    p95: '123.9086035',
  },
  {
    sex: 'female',
    ageInMonths: '73.5',
    p5: '107.4033481',
    p95: '124.5460585',
  },
  {
    sex: 'female',
    ageInMonths: '74.5',
    p5: '107.9342229',
    p95: '125.1804203',
  },
  {
    sex: 'female',
    ageInMonths: '75.5',
    p5: '108.4624465',
    p95: '125.8113907',
  },
  {
    sex: 'female',
    ageInMonths: '76.5',
    p5: '108.987746',
    p95: '126.4386798',
  },
  {
    sex: 'female',
    ageInMonths: '77.5',
    p5: '109.5098548',
    p95: '127.0620077',
  },
  {
    sex: 'female',
    ageInMonths: '78.5',
    p5: '110.0285133',
    p95: '127.6811055',
  },
  {
    sex: 'female',
    ageInMonths: '79.5',
    p5: '110.5434704',
    p95: '128.2957169',
  },
  {
    sex: 'female',
    ageInMonths: '80.5',
    p5: '111.0544841',
    p95: '128.9056',
  },
  {
    sex: 'female',
    ageInMonths: '81.5',
    p5: '111.5613221',
    p95: '129.5105281',
  },
  {
    sex: 'female',
    ageInMonths: '82.5',
    p5: '112.0637632',
    p95: '130.1102914',
  },
  {
    sex: 'female',
    ageInMonths: '83.5',
    p5: '112.5615976',
    p95: '130.7046982',
  },
  {
    sex: 'female',
    ageInMonths: '84.5',
    p5: '113.054628',
    p95: '131.2935761',
  },
  {
    sex: 'female',
    ageInMonths: '85.5',
    p5: '113.54267',
    p95: '131.876773',
  },
  {
    sex: 'female',
    ageInMonths: '86.5',
    p5: '114.0255532',
    p95: '132.4541587',
  },
  {
    sex: 'female',
    ageInMonths: '87.5',
    p5: '114.5031216',
    p95: '133.025626',
  },
  {
    sex: 'female',
    ageInMonths: '88.5',
    p5: '114.9752341',
    p95: '133.5910912',
  },
  {
    sex: 'female',
    ageInMonths: '89.5',
    p5: '115.4417656',
    p95: '134.150496',
  },
  {
    sex: 'female',
    ageInMonths: '90.5',
    p5: '115.9026074',
    p95: '134.7038082',
  },
  {
    sex: 'female',
    ageInMonths: '91.5',
    p5: '116.3576679',
    p95: '135.2510227',
  },
  {
    sex: 'female',
    ageInMonths: '92.5',
    p5: '116.8068731',
    p95: '135.7921628',
  },
  {
    sex: 'female',
    ageInMonths: '93.5',
    p5: '117.2501678',
    p95: '136.3272809',
  },
  {
    sex: 'female',
    ageInMonths: '94.5',
    p5: '117.6875155',
    p95: '136.8564598',
  },
  {
    sex: 'female',
    ageInMonths: '95.5',
    p5: '118.1188998',
    p95: '137.3798137',
  },
  {
    sex: 'female',
    ageInMonths: '96.5',
    p5: '118.5443251',
    p95: '137.8974887',
  },
  {
    sex: 'female',
    ageInMonths: '97.5',
    p5: '118.9638171',
    p95: '138.4096645',
  },
  {
    sex: 'female',
    ageInMonths: '98.5',
    p5: '119.3774239',
    p95: '138.9165546',
  },
  {
    sex: 'female',
    ageInMonths: '99.5',
    p5: '119.7852171',
    p95: '139.4184075',
  },
  {
    sex: 'female',
    ageInMonths: '100.5',
    p5: '120.1872927',
    p95: '139.9155075',
  },
  {
    sex: 'female',
    ageInMonths: '101.5',
    p5: '120.5837721',
    p95: '140.4081749',
  },
  {
    sex: 'female',
    ageInMonths: '102.5',
    p5: '120.9748035',
    p95: '140.8967672',
  },
  {
    sex: 'female',
    ageInMonths: '103.5',
    p5: '121.3605632',
    p95: '141.3816789',
  },
  {
    sex: 'female',
    ageInMonths: '104.5',
    p5: '121.7412571',
    p95: '141.8633417',
  },
  {
    sex: 'female',
    ageInMonths: '105.5',
    p5: '122.1171219',
    p95: '142.3422248',
  },
  {
    sex: 'female',
    ageInMonths: '106.5',
    p5: '122.4884272',
    p95: '142.818834',
  },
  {
    sex: 'female',
    ageInMonths: '107.5',
    p5: '122.8554769',
    p95: '143.2937108',
  },
  {
    sex: 'female',
    ageInMonths: '108.5',
    p5: '123.2186111',
    p95: '143.7674316',
  },
  {
    sex: 'female',
    ageInMonths: '109.5',
    p5: '123.5782083',
    p95: '144.2406053',
  },
  {
    sex: 'female',
    ageInMonths: '110.5',
    p5: '123.9346869',
    p95: '144.7138712',
  },
  {
    sex: 'female',
    ageInMonths: '111.5',
    p5: '124.2885075',
    p95: '145.1878952',
  },
  {
    sex: 'female',
    ageInMonths: '112.5',
    p5: '124.6401749',
    p95: '145.6633664',
  },
  {
    sex: 'female',
    ageInMonths: '113.5',
    p5: '124.9902397',
    p95: '146.1409913',
  },
  {
    sex: 'female',
    ageInMonths: '114.5',
    p5: '125.3393004',
    p95: '146.6214882',
  },
  {
    sex: 'female',
    ageInMonths: '115.5',
    p5: '125.6880049',
    p95: '147.1055797',
  },
  {
    sex: 'female',
    ageInMonths: '116.5',
    p5: '126.0370512',
    p95: '147.5939843',
  },
  {
    sex: 'female',
    ageInMonths: '117.5',
    p5: '126.3871885',
    p95: '148.0874065',
  },
  {
    sex: 'female',
    ageInMonths: '118.5',
    p5: '126.7392174',
    p95: '148.586526',
  },
  {
    sex: 'female',
    ageInMonths: '119.5',
    p5: '127.0939883',
    p95: '149.0919854',
  },
  {
    sex: 'female',
    ageInMonths: '120.5',
    p5: '127.4524005',
    p95: '149.6043767',
  },
  {
    sex: 'female',
    ageInMonths: '121.5',
    p5: '127.8153983',
    p95: '150.1242269',
  },
  {
    sex: 'female',
    ageInMonths: '122.5',
    p5: '128.1839668',
    p95: '150.6519828',
  },
  {
    sex: 'female',
    ageInMonths: '123.5',
    p5: '128.5591249',
    p95: '151.1879951',
  },
  {
    sex: 'female',
    ageInMonths: '124.5',
    p5: '128.9419168',
    p95: '151.7325029',
  },
  {
    sex: 'female',
    ageInMonths: '125.5',
    p5: '129.3334014',
    p95: '152.2856189',
  },
  {
    sex: 'female',
    ageInMonths: '126.5',
    p5: '129.7346372',
    p95: '152.8473131',
  },
  {
    sex: 'female',
    ageInMonths: '127.5',
    p5: '130.1466666',
    p95: '153.4174019',
  },
  {
    sex: 'female',
    ageInMonths: '128.5',
    p5: '130.5704957',
    p95: '153.9955367',
  },
  {
    sex: 'female',
    ageInMonths: '129.5',
    p5: '131.0070717',
    p95: '154.581196',
  },
  {
    sex: 'female',
    ageInMonths: '130.5',
    p5: '131.4572565',
    p95: '155.1736815',
  },
  {
    sex: 'female',
    ageInMonths: '131.5',
    p5: '131.9217986',
    p95: '155.7721177',
  },
  {
    sex: 'female',
    ageInMonths: '132.5',
    p5: '132.4013028',
    p95: '156.3754566',
  },
  {
    sex: 'female',
    ageInMonths: '133.5',
    p5: '132.8961979',
    p95: '156.9824866',
  },
  {
    sex: 'female',
    ageInMonths: '134.5',
    p5: '133.4067049',
    p95: '157.591847',
  },
  {
    sex: 'female',
    ageInMonths: '135.5',
    p5: '133.9328066',
    p95: '158.2020466',
  },
  {
    sex: 'female',
    ageInMonths: '136.5',
    p5: '134.4742195',
    p95: '158.8114866',
  },
  {
    sex: 'female',
    ageInMonths: '137.5',
    p5: '135.0303699',
    p95: '159.4184879',
  },
  {
    sex: 'female',
    ageInMonths: '138.5',
    p5: '135.6003795',
    p95: '160.0213216',
  },
  {
    sex: 'female',
    ageInMonths: '139.5',
    p5: '136.1830524',
    p95: '160.6182378',
  },
  {
    sex: 'female',
    ageInMonths: '140.5',
    p5: '136.7768804',
    p95: '161.2075007',
  },
  {
    sex: 'female',
    ageInMonths: '141.5',
    p5: '137.3800519',
    p95: '161.7874182',
  },
  {
    sex: 'female',
    ageInMonths: '142.5',
    p5: '137.9904798',
    p95: '162.3563754',
  },
  {
    sex: 'female',
    ageInMonths: '143.5',
    p5: '138.6058289',
    p95: '162.9128551',
  },
  {
    sex: 'female',
    ageInMonths: '144.5',
    p5: '139.2235689',
    p95: '163.4554684',
  },
  {
    sex: 'female',
    ageInMonths: '145.5',
    p5: '139.8410247',
    p95: '163.9829705',
  },
  {
    sex: 'female',
    ageInMonths: '146.5',
    p5: '140.4554388',
    p95: '164.4942764',
  },
  {
    sex: 'female',
    ageInMonths: '147.5',
    p5: '141.064036',
    p95: '164.9884705',
  },
  {
    sex: 'female',
    ageInMonths: '148.5',
    p5: '141.6640898',
    p95: '165.4648118',
  },
  {
    sex: 'female',
    ageInMonths: '149.5',
    p5: '142.2529855',
    p95: '165.9227345',
  },
  {
    sex: 'female',
    ageInMonths: '150.5',
    p5: '142.8282787',
    p95: '166.3618445',
  },
  {
    sex: 'female',
    ageInMonths: '151.5',
    p5: '143.3877452',
    p95: '166.7819123',
  },
  {
    sex: 'female',
    ageInMonths: '152.5',
    p5: '143.9294218',
    p95: '167.1828627',
  },
  {
    sex: 'female',
    ageInMonths: '153.5',
    p5: '144.4516354',
    p95: '167.5647631',
  },
  {
    sex: 'female',
    ageInMonths: '154.5',
    p5: '144.9530205',
    p95: '167.9278093',
  },
  {
    sex: 'female',
    ageInMonths: '155.5',
    p5: '145.4325259',
    p95: '168.2723104',
  },
  {
    sex: 'female',
    ageInMonths: '156.5',
    p5: '145.8894106',
    p95: '168.5986736',
  },
  {
    sex: 'female',
    ageInMonths: '157.5',
    p5: '146.3232308',
    p95: '168.9073892',
  },
  {
    sex: 'female',
    ageInMonths: '158.5',
    p5: '146.7338197',
    p95: '169.1990151',
  },
  {
    sex: 'female',
    ageInMonths: '159.5',
    p5: '147.1212613',
    p95: '169.474163',
  },
  {
    sex: 'female',
    ageInMonths: '160.5',
    p5: '147.4858611',
    p95: '169.7334849',
  },
  {
    sex: 'female',
    ageInMonths: '161.5',
    p5: '147.8281145',
    p95: '169.9776618',
  },
  {
    sex: 'female',
    ageInMonths: '162.5',
    p5: '148.148675',
    p95: '170.207392',
  },
  {
    sex: 'female',
    ageInMonths: '163.5',
    p5: '148.4483225',
    p95: '170.4233822',
  },
  {
    sex: 'female',
    ageInMonths: '164.5',
    p5: '148.7279342',
    p95: '170.6263392',
  },
  {
    sex: 'female',
    ageInMonths: '165.5',
    p5: '148.9884574',
    p95: '170.8169629',
  },
  {
    sex: 'female',
    ageInMonths: '166.5',
    p5: '149.2308852',
    p95: '170.9959407',
  },
  {
    sex: 'female',
    ageInMonths: '167.5',
    p5: '149.4562355',
    p95: '171.1639423',
  },
  {
    sex: 'female',
    ageInMonths: '168.5',
    p5: '149.6655332',
    p95: '171.3216174',
  },
  {
    sex: 'female',
    ageInMonths: '169.5',
    p5: '149.8597926',
    p95: '171.469589',
  },
  {
    sex: 'female',
    ageInMonths: '170.5',
    p5: '150.0400107',
    p95: '171.6084579',
  },
  {
    sex: 'female',
    ageInMonths: '171.5',
    p5: '150.2071532',
    p95: '171.7387957',
  },
  {
    sex: 'female',
    ageInMonths: '172.5',
    p5: '150.3621482',
    p95: '171.8611461',
  },
  {
    sex: 'female',
    ageInMonths: '173.5',
    p5: '150.5058813',
    p95: '171.9760242',
  },
  {
    sex: 'female',
    ageInMonths: '174.5',
    p5: '150.6391923',
    p95: '172.0839168',
  },
  {
    sex: 'female',
    ageInMonths: '175.5',
    p5: '150.7628729',
    p95: '172.1852824',
  },
  {
    sex: 'female',
    ageInMonths: '176.5',
    p5: '150.877665',
    p95: '172.2805514',
  },
  {
    sex: 'female',
    ageInMonths: '177.5',
    p5: '150.9842639',
    p95: '172.3701297',
  },
  {
    sex: 'female',
    ageInMonths: '178.5',
    p5: '151.0833153',
    p95: '172.4543957',
  },
  {
    sex: 'female',
    ageInMonths: '179.5',
    p5: '151.1754186',
    p95: '172.5337038',
  },
  {
    sex: 'female',
    ageInMonths: '180.5',
    p5: '151.2611287',
    p95: '172.6083849',
  },
  {
    sex: 'female',
    ageInMonths: '181.5',
    p5: '151.3409575',
    p95: '172.6787478',
  },
  {
    sex: 'female',
    ageInMonths: '182.5',
    p5: '151.415377',
    p95: '172.7450799',
  },
  {
    sex: 'female',
    ageInMonths: '183.5',
    p5: '151.4848208',
    p95: '172.8076491',
  },
  {
    sex: 'female',
    ageInMonths: '184.5',
    p5: '151.5496874',
    p95: '172.8667045',
  },
  {
    sex: 'female',
    ageInMonths: '185.5',
    p5: '151.610342',
    p95: '172.9224777',
  },
  {
    sex: 'female',
    ageInMonths: '186.5',
    p5: '151.6671193',
    p95: '172.9751838',
  },
  {
    sex: 'female',
    ageInMonths: '187.5',
    p5: '151.7203255',
    p95: '173.025023',
  },
  {
    sex: 'female',
    ageInMonths: '188.5',
    p5: '151.7702407',
    p95: '173.0721808',
  },
  {
    sex: 'female',
    ageInMonths: '189.5',
    p5: '151.8171212',
    p95: '173.1168298',
  },
  {
    sex: 'female',
    ageInMonths: '190.5',
    p5: '151.8612008',
    p95: '173.1591301',
  },
  {
    sex: 'female',
    ageInMonths: '191.5',
    p5: '151.9026934',
    p95: '173.1992303',
  },
  {
    sex: 'female',
    ageInMonths: '192.5',
    p5: '151.9417942',
    p95: '173.2372685',
  },
  {
    sex: 'female',
    ageInMonths: '193.5',
    p5: '151.9786817',
    p95: '173.2733728',
  },
  {
    sex: 'female',
    ageInMonths: '194.5',
    p5: '152.013519',
    p95: '173.3076624',
  },
  {
    sex: 'female',
    ageInMonths: '195.5',
    p5: '152.0464549',
    p95: '173.3402478',
  },
  {
    sex: 'female',
    ageInMonths: '196.5',
    p5: '152.0776257',
    p95: '173.3712319',
  },
  {
    sex: 'female',
    ageInMonths: '197.5',
    p5: '152.1071558',
    p95: '173.4007102',
  },
  {
    sex: 'female',
    ageInMonths: '198.5',
    p5: '152.1351593',
    p95: '173.4287717',
  },
  {
    sex: 'female',
    ageInMonths: '199.5',
    p5: '152.1617405',
    p95: '173.455499',
  },
  {
    sex: 'female',
    ageInMonths: '200.5',
    p5: '152.1869949',
    p95: '173.4809691',
  },
  {
    sex: 'female',
    ageInMonths: '201.5',
    p5: '152.2110102',
    p95: '173.5052538',
  },
  {
    sex: 'female',
    ageInMonths: '202.5',
    p5: '152.2338667',
    p95: '173.5284198',
  },
  {
    sex: 'female',
    ageInMonths: '203.5',
    p5: '152.2556383',
    p95: '173.5505296',
  },
  {
    sex: 'female',
    ageInMonths: '204.5',
    p5: '152.2763929',
    p95: '173.5716411',
  },
  {
    sex: 'female',
    ageInMonths: '205.5',
    p5: '152.296193',
    p95: '173.5918087',
  },
  {
    sex: 'female',
    ageInMonths: '206.5',
    p5: '152.3150959',
    p95: '173.6110831',
  },
  {
    sex: 'female',
    ageInMonths: '207.5',
    p5: '152.3331548',
    p95: '173.6295117',
  },
  {
    sex: 'female',
    ageInMonths: '208.5',
    p5: '152.3504187',
    p95: '173.6471389',
  },
  {
    sex: 'female',
    ageInMonths: '209.5',
    p5: '152.3669327',
    p95: '173.6640061',
  },
  {
    sex: 'female',
    ageInMonths: '210.5',
    p5: '152.3827387',
    p95: '173.6801522',
  },
  {
    sex: 'female',
    ageInMonths: '211.5',
    p5: '152.3978755',
    p95: '173.6956138',
  },
  {
    sex: 'female',
    ageInMonths: '212.5',
    p5: '152.412379',
    p95: '173.710425',
  },
  {
    sex: 'female',
    ageInMonths: '213.5',
    p5: '152.4262827',
    p95: '173.7246179',
  },
  {
    sex: 'female',
    ageInMonths: '214.5',
    p5: '152.4396177',
    p95: '173.7382228',
  },
  {
    sex: 'female',
    ageInMonths: '215.5',
    p5: '152.4524128',
    p95: '173.751268',
  },
  {
    sex: 'female',
    ageInMonths: '216.5',
    p5: '152.464695',
    p95: '173.7637802',
  },
  {
    sex: 'female',
    ageInMonths: '217.5',
    p5: '152.4764895',
    p95: '173.7757847',
  },
  {
    sex: 'female',
    ageInMonths: '218.5',
    p5: '152.4878198',
    p95: '173.787305',
  },
  {
    sex: 'female',
    ageInMonths: '219.5',
    p5: '152.498708',
    p95: '173.7983636',
  },
  {
    sex: 'female',
    ageInMonths: '220.5',
    p5: '152.5091747',
    p95: '173.8089816',
  },
  {
    sex: 'female',
    ageInMonths: '221.5',
    p5: '152.5192393',
    p95: '173.8191789',
  },
  {
    sex: 'female',
    ageInMonths: '222.5',
    p5: '152.52892',
    p95: '173.8289744',
  },
  {
    sex: 'female',
    ageInMonths: '223.5',
    p5: '152.5382338',
    p95: '173.8383858',
  },
  {
    sex: 'female',
    ageInMonths: '224.5',
    p5: '152.5471971',
    p95: '173.8474302',
  },
  {
    sex: 'female',
    ageInMonths: '225.5',
    p5: '152.5558248',
    p95: '173.8561235',
  },
  {
    sex: 'female',
    ageInMonths: '226.5',
    p5: '152.5641315',
    p95: '173.8644808',
  },
  {
    sex: 'female',
    ageInMonths: '227.5',
    p5: '152.5721307',
    p95: '173.8725166',
  },
  {
    sex: 'female',
    ageInMonths: '228.5',
    p5: '152.5798353',
    p95: '173.8802445',
  },
  {
    sex: 'female',
    ageInMonths: '229.5',
    p5: '152.5872574',
    p95: '173.8876774',
  },
  {
    sex: 'female',
    ageInMonths: '230.5',
    p5: '152.5944085',
    p95: '173.8948277',
  },
  {
    sex: 'female',
    ageInMonths: '231.5',
    p5: '152.6012996',
    p95: '173.9017071',
  },
  {
    sex: 'female',
    ageInMonths: '232.5',
    p5: '152.6079412',
    p95: '173.9083268',
  },
  {
    sex: 'female',
    ageInMonths: '233.5',
    p5: '152.6143431',
    p95: '173.9146973',
  },
  {
    sex: 'female',
    ageInMonths: '234.5',
    p5: '152.6205147',
    p95: '173.9208289',
  },
  {
    sex: 'female',
    ageInMonths: '235.5',
    p5: '152.626465',
    p95: '173.9267311',
  },
  {
    sex: 'female',
    ageInMonths: '236.5',
    p5: '152.6322026',
    p95: '173.9324132',
  },
  {
    sex: 'female',
    ageInMonths: '237.5',
    p5: '152.6377356',
    p95: '173.9378839',
  },
  {
    sex: 'female',
    ageInMonths: '238.5',
    p5: '152.6430718',
    p95: '173.9431517',
  },
  {
    sex: 'female',
    ageInMonths: '239.5',
    p5: '152.6482187',
    p95: '173.9482244',
  },
  {
    sex: 'female',
    ageInMonths: '240',
    p5: '152.6507234',
    p95: '173.9506901',
  },
];

export type Percentiles = {
  p5: number;
  p95: number;
};

export interface AgePercentileDef {
  ageUnits: 'months' | 'days' | 'years';
  age: number;
  percentiles: Percentiles;
}
export type GenderPercentileMap = {
  male: AgePercentileDef[];
  female: AgePercentileDef[];
};

const GenderWeightPercentileMap: GenderPercentileMap = weightPercentilesRaw.reduce(
  (accum, current) => {
    const { sex, ageInMonths, p5, p95 } = current;
    const age = parseFloat(ageInMonths);
    const percentiles: Percentiles = { p5: parseFloat(p5), p95: parseFloat(p95) };

    if (accum[sex as 'male' | 'female']) {
      accum[sex as 'male' | 'female'].push({
        ageUnits: 'months',
        age,
        percentiles,
      });
    }

    return accum;
  },
  {
    male: [] as AgePercentileDef[],
    female: [] as AgePercentileDef[],
  }
);

const GenderHeightPercentileMap: GenderPercentileMap = heightPercentilesRaw.reduce(
  (accum, current) => {
    const { sex, ageInMonths, p5, p95 } = current;
    const age = parseFloat(ageInMonths);
    const percentiles: Percentiles = { p5: parseFloat(p5), p95: parseFloat(p95) };

    if (accum[sex as 'male' | 'female']) {
      accum[sex as 'male' | 'female'].push({
        ageUnits: 'months',
        age,
        percentiles,
      });
    }

    return accum;
  },
  {
    male: [] as AgePercentileDef[],
    female: [] as AgePercentileDef[],
  }
);

const findApplicablePercentile = (
  patientAgeInMonths: number,
  agePercentiles: AgePercentileDef[]
): Percentiles | undefined => {
  const startOfScale = agePercentiles[0]?.age;
  const endOfScale = agePercentiles[agePercentiles.length - 1]?.age;
  if (patientAgeInMonths < startOfScale || patientAgeInMonths > endOfScale) {
    return undefined;
  }
  const matchingPercentiles = agePercentiles.find(({ age }) => {
    return patientAgeInMonths <= age;
  });
  return matchingPercentiles?.percentiles;
};

export const getWeightPercentileLow = (ageInMonths: number, sex: 'male' | 'female'): number => {
  const agePercentiles = GenderWeightPercentileMap[sex];
  const percentileToUse = findApplicablePercentile(ageInMonths, agePercentiles)?.p5;
  return percentileToUse ?? -Infinity;
};

export const getWeightPercentileHigh = (ageInMonths: number, sex: 'male' | 'female'): number => {
  const agePercentiles = GenderWeightPercentileMap[sex];
  const percentileToUse = findApplicablePercentile(ageInMonths, agePercentiles)?.p95;
  return percentileToUse ?? Infinity;
};
export const getHeightPercentileLow = (ageInMonths: number, sex: 'male' | 'female'): number | undefined => {
  const agePercentiles = GenderHeightPercentileMap[sex];
  const percentileToUse = findApplicablePercentile(ageInMonths, agePercentiles)?.p5;
  return percentileToUse ?? -Infinity;
};

export const getHeightPercentileHigh = (ageInMonths: number, sex: 'male' | 'female'): number | undefined => {
  const agePercentiles = GenderHeightPercentileMap[sex];
  const percentileToUse = findApplicablePercentile(ageInMonths, agePercentiles)?.p95;
  return percentileToUse ?? Infinity;
};
